// jshint ignore: start
var $ = require('jquery');
/*
 * This is a combination of JS that existed on the old site. It has not been
 * cleaned up and the source of the new app has not been used.
 */
var invalid = 'validation-error';

var uv = new Array();

for(i = 1;i < 54;i++)
{
	uv[i] = new Array();
}


// lat -90 -> 0 -> 90
uv[1][8] = new Array(1.11,1.56,2.04,2.50,2.92,3.24,3.39,3.39,2.91,2.16,1.38,0.72,0.29,0.08,0.00,0.00,0.00,0.00,0.00);
uv[2][8] = new Array(1.05,1.49,1.95,2.40,2.80,3.10,3.24,3.22,2.77,2.06,1.32,0.69,0.29,0.08,0.00,0.00,0.00,0.00,0.00);
uv[3][8] = new Array(0.96,1.38,1.82,2.25,2.64,2.94,3.08,3.06,2.64,1.98,1.28,0.69,0.29,0.09,0.00,0.00,0.00,0.00,0.00);
uv[4][8] = new Array(0.84,1.24,1.66,2.08,2.46,2.76,2.91,2.91,2.53,1.93,1.28,0.70,0.31,0.11,0.01,0.00,0.00,0.00,0.00);
uv[5][8] = new Array(0.71,1.07,1.47,1.87,2.25,2.56,2.73,2.77,2.45,1.91,1.30,0.74,0.35,0.13,0.03,0.00,0.00,0.00,0.00);
uv[6][8] = new Array(0.57,0.89,1.26,1.65,2.03,2.36,2.56,2.64,2.38,1.92,1.35,0.80,0.40,0.17,0.05,0.00,0.00,0.00,0.00);
uv[7][8] = new Array(0.43,0.71,1.05,1.43,1.81,2.15,2.39,2.51,2.34,1.95,1.43,0.89,0.47,0.22,0.08,0.01,0.00,0.00,0.00);
uv[8][8] = new Array(0.30,0.54,0.85,1.20,1.58,1.94,2.22,2.40,2.31,1.99,1.53,1.00,0.57,0.29,0.12,0.03,0.00,0.00,0.00);
uv[9][8] = new Array(0.19,0.39,0.66,0.98,1.35,1.73,2.06,2.29,2.28,2.06,1.65,1.14,0.69,0.38,0.18,0.07,0.00,0.00,0.00);
uv[10][8] = new Array(0.10,0.25,0.47,0.76,1.11,1.50,1.87,2.17,2.27,2.15,1.81,1.33,0.86,0.51,0.28,0.13,0.04,0.00,0.00);
uv[11][8] = new Array(0.04,0.15,0.33,0.58,0.92,1.31,1.71,2.07,2.26,2.24,1.97,1.51,1.03,0.66,0.39,0.20,0.09,0.02,0.00);
uv[12][8] = new Array(0.00,0.08,0.22,0.44,0.74,1.13,1.56,1.96,2.24,2.32,2.14,1.71,1.23,0.83,0.52,0.30,0.15,0.05,0.00);
uv[13][8] = new Array(0.00,0.03,0.13,0.31,0.59,0.96,1.40,1.85,2.21,2.40,2.30,1.93,1.45,1.03,0.69,0.42,0.24,0.11,0.03);
uv[14][8] = new Array(0.00,0.00,0.07,0.22,0.45,0.80,1.25,1.74,2.17,2.47,2.46,2.14,1.69,1.25,0.87,0.57,0.34,0.18,0.07);
uv[15][8] = new Array(0.00,0.00,0.03,0.14,0.34,0.66,1.11,1.62,2.12,2.51,2.60,2.35,1.93,1.48,1.08,0.74,0.47,0.27,0.12);
uv[16][8] = new Array(0.00,0.00,0.00,0.08,0.25,0.54,0.97,1.49,2.06,2.53,2.72,2.54,2.17,1.72,1.29,0.93,0.62,0.38,0.20);
uv[17][8] = new Array(0.00,0.00,0.00,0.04,0.18,0.44,0.84,1.37,1.97,2.53,2.81,2.72,2.39,1.96,1.52,1.13,0.79,0.51,0.29);
uv[18][8] = new Array(0.00,0.00,0.00,0.02,0.13,0.35,0.73,1.25,1.88,2.51,2.88,2.86,2.60,2.19,1.75,1.33,0.96,0.65,0.39);
uv[19][8] = new Array(0.00,0.00,0.00,0.00,0.08,0.28,0.63,1.13,1.78,2.46,2.90,2.97,2.78,2.40,1.96,1.54,1.14,0.80,0.50);
uv[20][8] = new Array(0.00,0.00,0.00,0.00,0.05,0.22,0.54,1.02,1.68,2.40,2.90,3.05,2.94,2.58,2.16,1.73,1.32,0.94,0.61);
uv[21][8] = new Array(0.00,0.00,0.00,0.00,0.03,0.17,0.46,0.92,1.58,2.32,2.88,3.09,3.05,2.74,2.34,1.90,1.48,1.09,0.73);
uv[22][8] = new Array(0.00,0.00,0.00,0.00,0.02,0.14,0.40,0.84,1.48,2.23,2.83,3.10,3.14,2.87,2.48,2.06,1.63,1.21,0.83);
uv[23][8] = new Array(0.00,0.00,0.00,0.00,0.01,0.11,0.35,0.76,1.39,2.15,2.77,3.09,3.19,2.96,2.60,2.18,1.75,1.32,0.92);
uv[24][8] = new Array(0.00,0.00,0.00,0.00,0.00,0.09,0.31,0.70,1.32,2.07,2.70,3.06,3.21,3.02,2.68,2.27,1.84,1.41,0.99);
uv[25][8] = new Array(0.00,0.00,0.00,0.00,0.00,0.08,0.29,0.66,1.26,1.99,2.64,3.02,3.21,3.04,2.72,2.33,1.90,1.46,1.04);
uv[26][8] = new Array(0.00,0.00,0.00,0.00,0.00,0.08,0.27,0.63,1.21,1.94,2.57,2.97,3.18,3.04,2.73,2.34,1.91,1.48,1.05);
uv[27][8] = new Array(0.00,0.00,0.00,0.00,0.00,0.08,0.27,0.62,1.19,1.90,2.52,2.91,3.14,3.01,2.71,2.32,1.90,1.46,1.03);
uv[28][8] = new Array(0.00,0.00,0.00,0.00,0.00,0.08,0.28,0.63,1.19,1.88,2.48,2.86,3.08,2.95,2.66,2.27,1.84,1.41,0.98);
uv[29][8] = new Array(0.00,0.00,0.00,0.00,0.00,0.10,0.30,0.66,1.21,1.88,2.45,2.82,3.02,2.87,2.57,2.18,1.75,1.32,0.91);
uv[30][8] = new Array(0.00,0.00,0.00,0.00,0.02,0.12,0.33,0.70,1.26,1.91,2.45,2.77,2.94,2.78,2.46,2.06,1.63,1.20,0.81);
uv[31][8] = new Array(0.00,0.00,0.00,0.00,0.03,0.15,0.38,0.77,1.33,1.97,2.46,2.74,2.86,2.67,2.33,1.92,1.49,1.07,0.69);
uv[32][8] = new Array(0.00,0.00,0.00,0.00,0.06,0.19,0.45,0.86,1.43,2.04,2.49,2.72,2.78,2.54,2.17,1.75,1.32,0.92,0.57);
uv[33][8] = new Array(0.00,0.00,0.00,0.01,0.09,0.25,0.54,0.97,1.56,2.14,2.53,2.70,2.69,2.40,2.00,1.57,1.14,0.76,0.44);
uv[34][8] = new Array(0.00,0.00,0.00,0.03,0.14,0.33,0.65,1.12,1.72,2.27,2.59,2.68,2.59,2.25,1.82,1.38,0.96,0.60,0.33);
uv[35][8] = new Array(0.00,0.00,0.00,0.07,0.20,0.43,0.80,1.30,1.90,2.41,2.66,2.66,2.49,2.09,1.63,1.18,0.78,0.46,0.22);
uv[36][8] = new Array(0.00,0.00,0.03,0.12,0.29,0.56,0.97,1.51,2.11,2.57,2.73,2.63,2.37,1.92,1.44,0.99,0.61,0.33,0.14);
uv[37][8] = new Array(0.00,0.00,0.07,0.20,0.41,0.73,1.18,1.75,2.34,2.73,2.79,2.60,2.24,1.74,1.24,0.80,0.46,0.22,0.07);
uv[38][8] = new Array(0.00,0.04,0.13,0.29,0.55,0.92,1.42,2.01,2.59,2.90,2.85,2.55,2.10,1.56,1.05,0.63,0.33,0.14,0.03);
uv[39][8] = new Array(0.01,0.08,0.21,0.42,0.72,1.14,1.68,2.30,2.84,3.05,2.89,2.48,1.95,1.37,0.87,0.48,0.22,0.07,0.00);
uv[40][8] = new Array(0.04,0.14,0.32,0.57,0.92,1.39,1.96,2.59,3.08,3.19,2.90,2.39,1.79,1.19,0.70,0.36,0.14,0.03,0.00);
uv[41][8] = new Array(0.09,0.23,0.45,0.75,1.15,1.66,2.26,2.88,3.31,3.29,2.89,2.28,1.61,1.01,0.55,0.25,0.08,0.00,0.00);
uv[42][8] = new Array(0.15,0.34,0.60,0.95,1.40,1.94,2.55,3.16,3.50,3.36,2.84,2.15,1.44,0.85,0.42,0.17,0.03,0.00,0.00);
uv[43][8] = new Array(0.23,0.47,0.78,1.18,1.66,2.23,2.83,3.41,3.66,3.39,2.76,2.00,1.26,0.69,0.32,0.10,0.00,0.00,0.00);
uv[44][8] = new Array(0.33,0.61,0.97,1.41,1.92,2.50,3.09,3.62,3.76,3.37,2.65,1.84,1.09,0.56,0.23,0.06,0.00,0.00,0.00);
uv[45][8] = new Array(0.45,0.77,1.17,1.64,2.18,2.76,3.31,3.79,3.82,3.32,2.52,1.67,0.94,0.44,0.16,0.02,0.00,0.00,0.00);
uv[46][8] = new Array(0.58,0.94,1.38,1.87,2.42,2.98,3.48,3.90,3.82,3.22,2.36,1.50,0.79,0.35,0.11,0.00,0.00,0.00,0.00);
uv[47][8] = new Array(0.71,1.11,1.57,2.08,2.62,3.16,3.61,3.95,3.77,3.09,2.19,1.34,0.67,0.27,0.07,0.00,0.00,0.00,0.00);
uv[48][8] = new Array(0.83,1.26,1.74,2.26,2.79,3.30,3.69,3.95,3.68,2.93,2.02,1.19,0.56,0.21,0.04,0.00,0.00,0.00,0.00);
uv[49][8] = new Array(0.94,1.39,1.89,2.40,2.91,3.38,3.71,3.90,3.55,2.77,1.86,1.05,0.47,0.16,0.02,0.00,0.00,0.00,0.00);
uv[50][8] = new Array(1.03,1.50,1.99,2.50,2.99,3.41,3.69,3.81,3.40,2.60,1.71,0.94,0.40,0.13,0.01,0.00,0.00,0.00,0.00);
uv[51][8] = new Array(1.09,1.56,2.05,2.55,3.01,3.40,3.62,3.69,3.24,2.44,1.58,0.84,0.35,0.11,0.00,0.00,0.00,0.00,0.00);
uv[52][8] = new Array(1.12,1.58,2.07,2.54,2.98,3.34,3.52,3.55,3.07,2.29,1.46,0.77,0.32,0.09,0.00,0.00,0.00,0.00,0.00);
uv[53][8] = new Array(1.10,1.56,2.03,2.49,2.91,3.24,3.39,3.39,2.92,2.16,1.38,0.72,0.29,0.08,0.00,0.00,0.00,0.00,0.00);
uv[1][9] = new Array(1.11,1.84,2.72,3.69,4.70,5.67,6.42,6.96,6.51,5.29,3.74,2.22,1.06,0.41,0.11,0.00,0.00,0.00,0.00);
uv[2][9] = new Array(1.05,1.77,2.63,3.59,4.59,5.54,6.27,6.78,6.33,5.17,3.67,2.19,1.05,0.42,0.11,0.00,0.00,0.00,0.00);
uv[3][9] = new Array(0.96,1.65,2.49,3.44,4.43,5.37,6.09,6.60,6.19,5.09,3.66,2.20,1.08,0.44,0.13,0.00,0.00,0.00,0.00);
uv[4][9] = new Array(0.84,1.50,2.31,3.24,4.22,5.17,5.90,6.43,6.08,5.07,3.69,2.26,1.14,0.49,0.16,0.01,0.00,0.00,0.00);
uv[5][9] = new Array(0.71,1.31,2.09,3.00,3.98,4.93,5.70,6.26,5.99,5.09,3.78,2.37,1.23,0.56,0.20,0.03,0.00,0.00,0.00);
uv[6][9] = new Array(0.56,1.11,1.84,2.72,3.70,4.67,5.49,6.10,5.93,5.15,3.92,2.53,1.37,0.65,0.25,0.06,0.00,0.00,0.00);
uv[7][9] = new Array(0.43,0.91,1.58,2.42,3.39,4.39,5.26,5.93,5.90,5.24,4.11,2.73,1.54,0.78,0.33,0.10,0.00,0.00,0.00);
uv[8][9] = new Array(0.30,0.71,1.32,2.12,3.07,4.08,5.02,5.77,5.87,5.37,4.33,2.98,1.76,0.94,0.43,0.15,0.02,0.00,0.00);
uv[9][9] = new Array(0.19,0.53,1.06,1.81,2.73,3.76,4.76,5.60,5.85,5.51,4.58,3.26,2.01,1.13,0.56,0.23,0.06,0.00,0.00);
uv[10][9] = new Array(0.10,0.35,0.80,1.47,2.35,3.39,4.45,5.39,5.82,5.68,4.90,3.63,2.35,1.40,0.75,0.35,0.12,0.01,0.00);
uv[11][9] = new Array(0.04,0.23,0.60,1.19,2.02,3.05,4.16,5.19,5.78,5.83,5.19,3.97,2.68,1.68,0.95,0.48,0.19,0.04,0.00);
uv[12][9] = new Array(0.00,0.14,0.43,0.94,1.72,2.72,3.87,4.96,5.71,5.95,5.46,4.33,3.04,1.98,1.19,0.64,0.29,0.09,0.00);
uv[13][9] = new Array(0.00,0.07,0.29,0.73,1.43,2.40,3.56,4.72,5.62,6.04,5.72,4.67,3.41,2.31,1.45,0.83,0.42,0.16,0.03);
uv[14][9] = new Array(0.00,0.02,0.19,0.55,1.17,2.09,3.25,4.46,5.49,6.10,5.94,5.01,3.78,2.66,1.74,1.05,0.57,0.25,0.07);
uv[15][9] = new Array(0.00,0.00,0.11,0.40,0.94,1.80,2.94,4.18,5.33,6.12,6.13,5.31,4.15,3.01,2.05,1.30,0.74,0.36,0.13);
uv[16][9] = new Array(0.00,0.00,0.06,0.28,0.75,1.53,2.64,3.89,5.14,6.09,6.26,5.58,4.51,3.36,2.36,1.55,0.94,0.49,0.20);
uv[17][9] = new Array(0.00,0.00,0.02,0.19,0.58,1.29,2.35,3.60,4.93,6.01,6.35,5.80,4.83,3.71,2.68,1.82,1.15,0.64,0.29);
uv[18][9] = new Array(0.00,0.00,0.00,0.13,0.45,1.08,2.08,3.32,4.70,5.90,6.38,5.98,5.12,4.02,2.99,2.09,1.37,0.80,0.39);
uv[19][9] = new Array(0.00,0.00,0.00,0.08,0.35,0.91,1.84,3.05,4.46,5.75,6.36,6.10,5.37,4.32,3.28,2.36,1.59,0.97,0.50);
uv[20][9] = new Array(0.00,0.00,0.00,0.05,0.27,0.76,1.63,2.80,4.22,5.59,6.31,6.18,5.57,4.57,3.54,2.61,1.80,1.13,0.61);
uv[21][9] = new Array(0.00,0.00,0.00,0.03,0.21,0.64,1.44,2.57,4.00,5.41,6.22,6.22,5.73,4.79,3.78,2.83,2.00,1.29,0.73);
uv[22][9] = new Array(0.00,0.00,0.00,0.01,0.16,0.55,1.29,2.37,3.79,5.23,6.12,6.22,5.85,4.97,3.98,3.03,2.17,1.44,0.83);
uv[23][9] = new Array(0.00,0.00,0.00,0.00,0.13,0.48,1.17,2.21,3.61,5.06,6.00,6.19,5.93,5.10,4.14,3.19,2.32,1.56,0.92);
uv[24][9] = new Array(0.00,0.00,0.00,0.00,0.11,0.43,1.08,2.08,3.46,4.92,5.89,6.15,5.97,5.20,4.26,3.32,2.44,1.65,0.99);
uv[25][9] = new Array(0.00,0.00,0.00,0.00,0.10,0.40,1.02,1.99,3.35,4.80,5.79,6.10,5.99,5.26,4.35,3.40,2.51,1.71,1.04);
uv[26][9] = new Array(0.00,0.00,0.00,0.00,0.10,0.38,0.99,1.94,3.28,4.71,5.70,6.05,5.99,5.29,4.39,3.45,2.55,1.74,1.05);
uv[27][9] = new Array(0.00,0.00,0.00,0.00,0.10,0.38,0.98,1.92,3.25,4.67,5.64,6.00,5.97,5.28,4.39,3.44,2.54,1.72,1.03);
uv[28][9] = new Array(0.00,0.00,0.00,0.00,0.11,0.40,1.00,1.95,3.27,4.67,5.62,5.96,5.93,5.24,4.35,3.40,2.48,1.67,0.98);
uv[29][9] = new Array(0.00,0.00,0.00,0.00,0.13,0.44,1.06,2.02,3.34,4.71,5.62,5.94,5.88,5.18,4.27,3.31,2.39,1.58,0.91);
uv[30][9] = new Array(0.00,0.00,0.00,0.02,0.16,0.49,1.14,2.13,3.46,4.81,5.66,5.92,5.83,5.09,4.15,3.17,2.25,1.45,0.81);
uv[31][9] = new Array(0.00,0.00,0.00,0.03,0.20,0.57,1.26,2.28,3.64,4.94,5.72,5.92,5.76,4.97,4.00,3.01,2.09,1.30,0.69);
uv[32][9] = new Array(0.00,0.00,0.00,0.06,0.26,0.68,1.42,2.49,3.86,5.12,5.82,5.93,5.68,4.83,3.82,2.80,1.89,1.13,0.57);
uv[33][9] = new Array(0.00,0.00,0.00,0.10,0.34,0.81,1.62,2.74,4.13,5.34,5.93,5.94,5.57,4.65,3.60,2.57,1.67,0.95,0.44);
uv[34][9] = new Array(0.00,0.00,0.02,0.15,0.44,0.98,1.86,3.04,4.45,5.59,6.07,5.95,5.45,4.45,3.35,2.31,1.44,0.77,0.33);
uv[35][9] = new Array(0.00,0.00,0.05,0.23,0.58,1.19,2.14,3.39,4.81,5.87,6.20,5.94,5.30,4.22,3.08,2.04,1.21,0.60,0.22);
uv[36][9] = new Array(0.00,0.00,0.10,0.32,0.74,1.44,2.47,3.78,5.19,6.15,6.33,5.91,5.12,3.95,2.79,1.77,0.98,0.44,0.14);
uv[37][9] = new Array(0.00,0.03,0.17,0.45,0.95,1.73,2.84,4.21,5.60,6.44,6.44,5.86,4.91,3.67,2.48,1.49,0.77,0.31,0.07);
uv[38][9] = new Array(0.00,0.07,0.26,0.61,1.19,2.06,3.25,4.66,6.02,6.70,6.53,5.77,4.67,3.36,2.17,1.23,0.58,0.20,0.03);
uv[39][9] = new Array(0.01,0.13,0.37,0.80,1.47,2.42,3.67,5.13,6.42,6.94,6.57,5.63,4.39,3.03,1.87,0.99,0.42,0.12,0.00);
uv[40][9] = new Array(0.04,0.20,0.52,1.03,1.77,2.81,4.12,5.59,6.79,7.13,6.56,5.45,4.08,2.70,1.57,0.77,0.29,0.06,0.00);
uv[41][9] = new Array(0.09,0.31,0.69,1.28,2.11,3.21,4.56,6.04,7.12,7.26,6.49,5.23,3.75,2.37,1.30,0.58,0.19,0.02,0.00);
uv[42][9] = new Array(0.15,0.43,0.89,1.56,2.47,3.62,4.99,6.44,7.40,7.33,6.37,4.97,3.41,2.05,1.05,0.43,0.11,0.00,0.00);
uv[43][9] = new Array(0.23,0.58,1.12,1.86,2.83,4.03,5.39,6.80,7.60,7.32,6.19,4.67,3.06,1.75,0.84,0.30,0.06,0.00,0.00);
uv[44][9] = new Array(0.33,0.75,1.36,2.17,3.19,4.41,5.75,7.10,7.73,7.25,5.97,4.35,2.72,1.47,0.65,0.21,0.02,0.00,0.00);
uv[45][9] = new Array(0.45,0.94,1.61,2.47,3.53,4.76,6.05,7.32,7.78,7.11,5.70,4.02,2.40,1.23,0.50,0.14,0.00,0.00,0.00);
uv[46][9] = new Array(0.58,1.12,1.86,2.77,3.85,5.07,6.30,7.47,7.75,6.92,5.41,3.69,2.11,1.02,0.39,0.09,0.00,0.00,0.00);
uv[47][9] = new Array(0.71,1.31,2.09,3.03,4.13,5.33,6.49,7.55,7.66,6.69,5.10,3.37,1.84,0.85,0.29,0.05,0.00,0.00,0.00);
uv[48][9] = new Array(0.83,1.48,2.30,3.27,4.37,5.53,6.61,7.56,7.52,6.43,4.80,3.08,1.62,0.71,0.23,0.03,0.00,0.00,0.00);
uv[49][9] = new Array(0.94,1.63,2.48,3.46,4.55,5.67,6.67,7.51,7.34,6.17,4.52,2.82,1.43,0.60,0.18,0.01,0.00,0.00,0.00);
uv[50][9] = new Array(1.03,1.75,2.62,3.60,4.67,5.75,6.67,7.42,7.13,5.91,4.26,2.61,1.28,0.52,0.14,0.00,0.00,0.00,0.00);
uv[51][9] = new Array(1.09,1.83,2.70,3.69,4.74,5.77,6.62,7.28,6.92,5.67,4.04,2.43,1.17,0.46,0.12,0.00,0.00,0.00,0.00);
uv[52][9] = new Array(1.12,1.86,2.74,3.71,4.74,5.74,6.53,7.13,6.70,5.47,3.87,2.30,1.10,0.43,0.11,0.00,0.00,0.00,0.00);
uv[53][9] = new Array(1.10,1.84,2.71,3.68,4.69,5.66,6.41,6.95,6.51,5.30,3.75,2.22,1.06,0.41,0.11,0.00,0.00,0.00,0.00);
uv[1][10] = new Array(1.10,2.08,3.34,4.83,6.48,8.18,9.66,10.91,10.65,9.07,6.76,4.26,2.17,0.94,0.30,0.04,0.00,0.00,0.00);
uv[2][10] = new Array(1.05,2.01,3.26,4.75,6.41,8.10,9.56,10.79,10.53,9.00,6.74,4.26,2.19,0.96,0.31,0.05,0.00,0.00,0.00);
uv[3][10] = new Array(0.96,1.89,3.12,4.61,6.27,7.97,9.44,10.67,10.44,8.99,6.79,4.33,2.26,1.01,0.35,0.06,0.00,0.00,0.00);
uv[4][10] = new Array(0.84,1.73,2.93,4.41,6.08,7.79,9.29,10.54,10.38,9.05,6.92,4.47,2.38,1.10,0.40,0.09,0.00,0.00,0.00);
uv[5][10] = new Array(0.71,1.53,2.69,4.14,5.82,7.56,9.11,10.41,10.36,9.16,7.12,4.69,2.56,1.23,0.48,0.12,0.00,0.00,0.00);
uv[6][10] = new Array(0.56,1.31,2.41,3.83,5.50,7.28,8.90,10.26,10.35,9.31,7.38,4.96,2.79,1.40,0.58,0.17,0.01,0.00,0.00);
uv[7][10] = new Array(0.42,1.08,2.11,3.48,5.14,6.95,8.65,10.09,10.35,9.51,7.70,5.30,3.08,1.61,0.72,0.24,0.03,0.00,0.00);
uv[8][10] = new Array(0.30,0.86,1.79,3.11,4.75,6.58,8.36,9.90,10.35,9.72,8.05,5.69,3.43,1.87,0.88,0.33,0.07,0.00,0.00);
uv[9][10] = new Array(0.19,0.65,1.48,2.71,4.32,6.17,8.03,9.67,10.32,9.93,8.43,6.12,3.82,2.18,1.09,0.45,0.13,0.00,0.00);
uv[10][10] = new Array(0.10,0.45,1.15,2.27,3.80,5.65,7.59,9.37,10.27,10.16,8.88,6.65,4.32,2.58,1.38,0.63,0.22,0.03,0.00);
uv[11][10] = new Array(0.04,0.30,0.89,1.89,3.35,5.17,7.18,9.05,10.17,10.33,9.25,7.11,4.78,2.97,1.66,0.82,0.32,0.07,0.00);
uv[12][10] = new Array(0.00,0.19,0.66,1.55,2.90,4.69,6.72,8.68,10.01,10.44,9.58,7.57,5.27,3.39,1.99,1.04,0.45,0.13,0.00);
uv[13][10] = new Array(0.00,0.11,0.47,1.23,2.48,4.19,6.24,8.27,9.80,10.50,9.87,8.00,5.75,3.82,2.34,1.29,0.61,0.21,0.03);
uv[14][10] = new Array(0.00,0.05,0.32,0.96,2.08,3.71,5.75,7.82,9.53,10.49,10.10,8.39,6.23,4.27,2.71,1.57,0.80,0.32,0.07);
uv[15][10] = new Array(0.00,0.01,0.21,0.73,1.72,3.25,5.25,7.34,9.22,10.41,10.26,8.74,6.69,4.72,3.10,1.87,1.01,0.44,0.13);
uv[16][10] = new Array(0.00,0.00,0.13,0.55,1.41,2.82,4.75,6.86,8.86,10.27,10.35,9.03,7.11,5.15,3.49,2.19,1.24,0.59,0.20);
uv[17][10] = new Array(0.00,0.00,0.07,0.40,1.14,2.43,4.28,6.37,8.48,10.07,10.38,9.25,7.49,5.57,3.87,2.51,1.48,0.75,0.29);
uv[18][10] = new Array(0.00,0.00,0.03,0.29,0.91,2.08,3.84,5.89,8.07,9.83,10.34,9.41,7.82,5.95,4.24,2.84,1.74,0.93,0.39);
uv[19][10] = new Array(0.00,0.00,0.01,0.20,0.73,1.78,3.44,5.44,7.67,9.56,10.24,9.52,8.11,6.29,4.59,3.15,1.99,1.11,0.50);
uv[20][10] = new Array(0.00,0.00,0.00,0.14,0.59,1.53,3.08,5.03,7.28,9.27,10.11,9.57,8.34,6.60,4.91,3.44,2.23,1.29,0.61);
uv[21][10] = new Array(0.00,0.00,0.00,0.10,0.48,1.32,2.78,4.67,6.92,8.99,9.96,9.59,8.53,6.86,5.20,3.71,2.46,1.46,0.73);
uv[22][10] = new Array(0.00,0.00,0.00,0.07,0.40,1.16,2.53,4.36,6.61,8.72,9.79,9.58,8.68,7.09,5.44,3.95,2.66,1.62,0.83);
uv[23][10] = new Array(0.00,0.00,0.00,0.05,0.34,1.04,2.33,4.10,6.34,8.48,9.63,9.55,8.79,7.27,5.65,4.15,2.84,1.76,0.92);
uv[24][10] = new Array(0.00,0.00,0.00,0.04,0.30,0.95,2.18,3.91,6.13,8.28,9.49,9.51,8.88,7.42,5.82,4.31,2.97,1.86,0.99);
uv[25][10] = new Array(0.00,0.00,0.00,0.04,0.28,0.90,2.08,3.77,5.98,8.14,9.38,9.47,8.94,7.52,5.94,4.42,3.07,1.93,1.04);
uv[26][10] = new Array(0.00,0.00,0.00,0.03,0.27,0.87,2.03,3.70,5.90,8.05,9.30,9.44,8.98,7.60,6.03,4.49,3.12,1.96,1.05);
uv[27][10] = new Array(0.00,0.00,0.00,0.04,0.28,0.88,2.03,3.70,5.89,8.03,9.27,9.43,9.01,7.64,6.06,4.51,3.12,1.95,1.03);
uv[28][10] = new Array(0.00,0.00,0.00,0.05,0.30,0.91,2.08,3.76,5.96,8.08,9.28,9.44,9.02,7.64,6.05,4.48,3.07,1.89,0.98);
uv[29][10] = new Array(0.00,0.00,0.00,0.06,0.34,0.98,2.17,3.88,6.10,8.19,9.34,9.47,9.02,7.62,6.00,4.40,2.98,1.80,0.91);
uv[30][10] = new Array(0.00,0.00,0.00,0.09,0.39,1.07,2.32,4.07,6.31,8.37,9.44,9.51,9.01,7.55,5.89,4.27,2.84,1.67,0.81);
uv[31][10] = new Array(0.00,0.00,0.00,0.12,0.47,1.21,2.51,4.33,6.60,8.61,9.59,9.56,8.97,7.45,5.74,4.09,2.65,1.50,0.69);
uv[32][10] = new Array(0.00,0.00,0.01,0.16,0.57,1.38,2.77,4.65,6.95,8.90,9.76,9.62,8.91,7.30,5.53,3.86,2.43,1.32,0.57);
uv[33][10] = new Array(0.00,0.00,0.03,0.23,0.70,1.60,3.07,5.04,7.37,9.23,9.95,9.67,8.81,7.11,5.28,3.59,2.18,1.12,0.44);
uv[34][10] = new Array(0.00,0.00,0.06,0.31,0.86,1.86,3.44,5.49,7.83,9.60,10.15,9.70,8.67,6.86,4.98,3.28,1.91,0.92,0.33);
uv[35][10] = new Array(0.00,0.00,0.11,0.43,1.06,2.17,3.85,5.99,8.34,9.98,10.34,9.71,8.48,6.56,4.63,2.94,1.63,0.73,0.22);
uv[36][10] = new Array(0.00,0.01,0.18,0.57,1.31,2.52,4.32,6.54,8.87,10.36,10.51,9.66,8.23,6.21,4.25,2.59,1.35,0.55,0.14);
uv[37][10] = new Array(0.00,0.05,0.27,0.75,1.59,2.92,4.82,7.12,9.41,10.72,10.63,9.57,7.92,5.82,3.84,2.23,1.08,0.39,0.07);
uv[38][10] = new Array(0.00,0.10,0.39,0.96,1.92,3.36,5.35,7.71,9.94,11.04,10.70,9.41,7.56,5.38,3.41,1.88,0.84,0.26,0.03);
uv[39][10] = new Array(0.01,0.17,0.54,1.21,2.28,3.84,5.90,8.31,10.44,11.30,10.70,9.18,7.14,4.91,2.98,1.55,0.63,0.16,0.00);
uv[40][10] = new Array(0.04,0.26,0.72,1.49,2.67,4.33,6.46,8.88,10.88,11.49,10.63,8.89,6.67,4.42,2.56,1.24,0.45,0.09,0.00);
uv[41][10] = new Array(0.09,0.37,0.93,1.81,3.09,4.83,7.00,9.42,11.25,11.59,10.48,8.53,6.17,3.93,2.16,0.97,0.31,0.04,0.00);
uv[42][10] = new Array(0.15,0.52,1.16,2.15,3.53,5.34,7.52,9.90,11.55,11.61,10.25,8.11,5.65,3.45,1.79,0.74,0.20,0.00,0.00);
uv[43][10] = new Array(0.23,0.68,1.43,2.50,3.96,5.83,8.00,10.32,11.75,11.54,9.95,7.66,5.13,3.00,1.47,0.55,0.12,0.00,0.00);
uv[44][10] = new Array(0.34,0.87,1.70,2.87,4.40,6.29,8.43,10.66,11.87,11.38,9.59,7.17,4.61,2.58,1.18,0.40,0.07,0.00,0.00);
uv[45][10] = new Array(0.45,1.07,1.99,3.23,4.81,6.72,8.79,10.92,11.90,11.16,9.20,6.69,4.13,2.20,0.95,0.29,0.03,0.00,0.00);
uv[46][10] = new Array(0.58,1.27,2.27,3.58,5.20,7.10,9.10,11.11,11.85,10.89,8.78,6.21,3.69,1.88,0.76,0.20,0.00,0.00,0.00);
uv[47][10] = new Array(0.71,1.48,2.54,3.90,5.55,7.42,9.34,11.22,11.73,10.58,8.37,5.76,3.30,1.61,0.61,0.14,0.00,0.00,0.00);
uv[48][10] = new Array(0.83,1.67,2.79,4.19,5.85,7.69,9.52,11.26,11.57,10.26,7.97,5.35,2.96,1.39,0.50,0.10,0.00,0.00,0.00);
uv[49][10] = new Array(0.94,1.83,3.00,4.43,6.09,7.90,9.64,11.25,11.38,9.95,7.61,5.00,2.69,1.22,0.41,0.07,0.00,0.00,0.00);
uv[50][10] = new Array(1.03,1.96,3.17,4.62,6.28,8.06,9.70,11.20,11.18,9.66,7.30,4.71,2.47,1.09,0.35,0.05,0.00,0.00,0.00);
uv[51][10] = new Array(1.09,2.05,3.28,4.75,6.41,8.15,9.72,11.12,10.98,9.41,7.05,4.49,2.32,1.00,0.32,0.04,0.00,0.00,0.00);
uv[52][10] = new Array(1.12,2.09,3.33,4.81,6.47,8.18,9.70,11.02,10.80,9.21,6.87,4.34,2.22,0.95,0.30,0.04,0.00,0.00,0.00);
uv[53][10] = new Array(1.10,2.08,3.33,4.81,6.46,8.16,9.64,10.90,10.65,9.08,6.77,4.27,2.18,0.94,0.30,0.04,0.00,0.00,0.00);
uv[1][11] = new Array(1.10,2.24,3.78,5.66,7.82,10.09,12.17,14.03,13.98,12.18,9.32,6.05,3.19,1.44,0.49,0.09,0.00,0.00,0.00);
uv[2][11] = new Array(1.05,2.18,3.72,5.62,7.80,10.10,12.18,14.03,13.97,12.22,9.39,6.11,3.24,1.48,0.52,0.11,0.00,0.00,0.00);
uv[3][11] = new Array(0.96,2.06,3.59,5.50,7.71,10.04,12.15,14.01,14.00,12.33,9.55,6.27,3.37,1.57,0.58,0.13,0.00,0.00,0.00);
uv[4][11] = new Array(0.84,1.89,3.39,5.31,7.54,9.91,12.08,13.98,14.05,12.51,9.80,6.51,3.56,1.71,0.66,0.17,0.00,0.00,0.00);
uv[5][11] = new Array(0.71,1.68,3.14,5.05,7.30,9.72,11.96,13.92,14.12,12.74,10.13,6.83,3.83,1.90,0.77,0.22,0.01,0.00,0.00);
uv[6][11] = new Array(0.56,1.45,2.85,4.72,6.98,9.45,11.78,13.82,14.19,13.00,10.51,7.22,4.15,2.13,0.91,0.29,0.04,0.00,0.00);
uv[7][11] = new Array(0.42,1.21,2.52,4.34,6.59,9.10,11.53,13.67,14.24,13.28,10.94,7.67,4.54,2.42,1.10,0.38,0.07,0.00,0.00);
uv[8][11] = new Array(0.30,0.97,2.17,3.91,6.14,8.69,11.22,13.47,14.25,13.56,11.39,8.16,4.98,2.76,1.32,0.51,0.12,0.00,0.00);
uv[9][11] = new Array(0.19,0.75,1.82,3.46,5.64,8.20,10.82,13.19,14.22,13.81,11.85,8.69,5.47,3.14,1.58,0.66,0.19,0.01,0.00);
uv[10][11] = new Array(0.10,0.52,1.43,2.93,5.02,7.57,10.28,12.78,14.11,14.05,12.36,9.31,6.07,3.63,1.94,0.88,0.30,0.04,0.00);
uv[11][11] = new Array(0.04,0.36,1.12,2.48,4.46,6.98,9.75,12.34,13.92,14.19,12.75,9.83,6.62,4.10,2.28,1.11,0.42,0.09,0.00);
uv[12][11] = new Array(0.00,0.23,0.85,2.05,3.91,6.35,9.15,11.82,13.65,14.24,13.08,10.32,7.17,4.58,2.66,1.37,0.58,0.16,0.00);
uv[13][11] = new Array(0.00,0.14,0.62,1.66,3.36,5.72,8.51,11.25,13.30,14.21,13.33,10.77,7.70,5.08,3.07,1.66,0.76,0.25,0.03);
uv[14][11] = new Array(0.00,0.07,0.44,1.31,2.85,5.09,7.85,10.62,12.88,14.09,13.50,11.16,8.22,5.58,3.49,1.98,0.97,0.36,0.07);
uv[15][11] = new Array(0.00,0.02,0.30,1.02,2.39,4.48,7.17,9.96,12.39,13.89,13.59,11.48,8.70,6.07,3.92,2.32,1.20,0.50,0.13);
uv[16][11] = new Array(0.00,0.00,0.19,0.78,1.98,3.91,6.51,9.29,11.87,13.62,13.60,11.74,9.14,6.54,4.35,2.67,1.46,0.66,0.20);
uv[17][11] = new Array(0.00,0.00,0.12,0.58,1.62,3.39,5.88,8.62,11.32,13.29,13.53,11.92,9.53,6.98,4.77,3.02,1.73,0.83,0.29);
uv[18][11] = new Array(0.00,0.00,0.07,0.43,1.32,2.93,5.30,7.99,10.76,12.92,13.40,12.05,9.87,7.39,5.17,3.37,2.00,1.02,0.39);
uv[19][11] = new Array(0.00,0.00,0.03,0.32,1.08,2.53,4.77,7.39,10.23,12.53,13.23,12.12,10.17,7.76,5.55,3.71,2.27,1.21,0.50);
uv[20][11] = new Array(0.00,0.00,0.01,0.24,0.88,2.20,4.31,6.86,9.72,12.15,13.03,12.15,10.41,8.10,5.90,4.03,2.53,1.40,0.62);
uv[21][11] = new Array(0.00,0.00,0.00,0.18,0.74,1.93,3.91,6.39,9.27,11.79,12.82,12.15,10.62,8.39,6.22,4.33,2.78,1.58,0.73);
uv[22][11] = new Array(0.00,0.00,0.00,0.14,0.62,1.71,3.59,6.00,8.87,11.46,12.62,12.13,10.80,8.65,6.50,4.59,3.00,1.74,0.83);
uv[23][11] = new Array(0.00,0.00,0.00,0.11,0.54,1.55,3.34,5.69,8.56,11.19,12.45,12.11,10.95,8.88,6.75,4.82,3.19,1.89,0.92);
uv[24][11] = new Array(0.00,0.00,0.00,0.09,0.49,1.44,3.15,5.46,8.32,10.98,12.31,12.09,11.08,9.07,6.96,5.01,3.35,2.00,0.99);
uv[25][11] = new Array(0.00,0.00,0.00,0.08,0.46,1.37,3.03,5.31,8.17,10.85,12.22,12.09,11.19,9.23,7.12,5.16,3.46,2.07,1.04);
uv[26][11] = new Array(0.00,0.00,0.00,0.08,0.45,1.34,2.98,5.24,8.11,10.79,12.18,12.12,11.29,9.35,7.25,5.26,3.52,2.11,1.05);
uv[27][11] = new Array(0.00,0.00,0.00,0.09,0.46,1.35,2.99,5.26,8.14,10.82,12.20,12.16,11.38,9.45,7.32,5.30,3.54,2.10,1.03);
uv[28][11] = new Array(0.00,0.00,0.00,0.10,0.49,1.40,3.06,5.36,8.26,10.92,12.27,12.23,11.45,9.50,7.35,5.29,3.50,2.05,0.98);
uv[29][11] = new Array(0.00,0.00,0.00,0.12,0.55,1.50,3.20,5.54,8.47,11.11,12.40,12.32,11.51,9.52,7.32,5.22,3.40,1.95,0.91);
uv[30][11] = new Array(0.00,0.00,0.00,0.16,0.62,1.63,3.40,5.80,8.77,11.37,12.57,12.42,11.54,9.49,7.23,5.09,3.26,1.81,0.81);
uv[31][11] = new Array(0.00,0.00,0.01,0.20,0.73,1.81,3.66,6.14,9.15,11.69,12.78,12.52,11.54,9.40,7.08,4.91,3.06,1.65,0.69);
uv[32][11] = new Array(0.00,0.00,0.03,0.27,0.86,2.03,3.98,6.55,9.59,12.06,13.01,12.62,11.49,9.25,6.87,4.66,2.82,1.45,0.57);
uv[33][11] = new Array(0.00,0.00,0.06,0.35,1.03,2.31,4.36,7.03,10.10,12.47,13.24,12.69,11.39,9.04,6.59,4.36,2.55,1.24,0.44);
uv[34][11] = new Array(0.00,0.00,0.10,0.46,1.24,2.63,4.80,7.57,10.66,12.89,13.47,12.72,11.22,8.76,6.24,4.01,2.25,1.03,0.33);
uv[35][11] = new Array(0.00,0.00,0.16,0.60,1.48,3.00,5.29,8.16,11.24,13.32,13.67,12.70,10.98,8.40,5.84,3.63,1.93,0.82,0.22);
uv[36][11] = new Array(0.00,0.02,0.24,0.77,1.77,3.42,5.83,8.78,11.83,13.72,13.82,12.62,10.66,7.97,5.38,3.21,1.62,0.62,0.14);
uv[37][11] = new Array(0.00,0.06,0.35,0.98,2.11,3.88,6.40,9.43,12.41,14.07,13.90,12.45,10.26,7.48,4.89,2.79,1.31,0.45,0.07);
uv[38][11] = new Array(0.00,0.12,0.49,1.23,2.48,4.38,6.99,10.07,12.96,14.37,13.90,12.20,9.78,6.93,4.36,2.37,1.03,0.31,0.03);
uv[39][11] = new Array(0.01,0.19,0.65,1.51,2.89,4.90,7.59,10.71,13.46,14.58,13.82,11.86,9.22,6.33,3.83,1.97,0.78,0.20,0.00);
uv[40][11] = new Array(0.04,0.29,0.85,1.83,3.33,5.45,8.18,11.30,13.89,14.71,13.65,11.44,8.61,5.72,3.31,1.59,0.57,0.11,0.00);
uv[41][11] = new Array(0.09,0.42,1.08,2.18,3.79,6.00,8.76,11.86,14.24,14.73,13.38,10.95,7.97,5.10,2.81,1.26,0.40,0.05,0.00);
uv[42][11] = new Array(0.15,0.57,1.34,2.55,4.26,6.54,9.30,12.35,14.50,14.67,13.04,10.40,7.30,4.50,2.35,0.98,0.27,0.01,0.00);
uv[43][11] = new Array(0.24,0.75,1.63,2.94,4.74,7.07,9.81,12.77,14.67,14.52,12.63,9.82,6.64,3.93,1.95,0.74,0.17,0.00,0.00);
uv[44][11] = new Array(0.34,0.94,1.92,3.33,5.21,7.57,10.26,13.12,14.75,14.29,12.18,9.22,6.01,3.41,1.59,0.55,0.10,0.00,0.00);
uv[45][11] = new Array(0.45,1.15,2.23,3.73,5.67,8.04,10.66,13.40,14.76,14.01,11.69,8.62,5.41,2.94,1.30,0.41,0.05,0.00,0.00);
uv[46][11] = new Array(0.58,1.37,2.54,4.11,6.10,8.47,11.01,13.62,14.70,13.69,11.21,8.06,4.88,2.54,1.06,0.30,0.02,0.00,0.00);
uv[47][11] = new Array(0.71,1.58,2.83,4.47,6.49,8.85,11.30,13.77,14.60,13.37,10.75,7.54,4.41,2.21,0.87,0.22,0.00,0.00,0.00);
uv[48][11] = new Array(0.83,1.78,3.10,4.80,6.85,9.18,11.55,13.87,14.47,13.05,10.32,7.08,4.02,1.94,0.73,0.17,0.00,0.00,0.00);
uv[49][11] = new Array(0.95,1.96,3.34,5.08,7.16,9.47,11.74,13.94,14.34,12.76,9.96,6.70,3.70,1.74,0.62,0.13,0.00,0.00,0.00);
uv[50][11] = new Array(1.03,2.10,3.53,5.32,7.41,9.70,11.90,13.98,14.20,12.51,9.67,6.40,3.46,1.59,0.55,0.11,0.00,0.00,0.00);
uv[51][11] = new Array(1.09,2.20,3.67,5.49,7.60,9.87,12.01,14.00,14.10,12.33,9.46,6.20,3.30,1.49,0.51,0.09,0.00,0.00,0.00);
uv[52][11] = new Array(1.12,2.24,3.75,5.60,7.73,10.00,12.09,14.01,14.02,12.22,9.34,6.08,3.21,1.44,0.49,0.09,0.00,0.00,0.00);
uv[53][11] = new Array(1.10,2.24,3.76,5.64,7.79,10.06,12.14,14.01,13.97,12.18,9.32,6.05,3.19,1.44,0.49,0.09,0.00,0.00,0.00);
uv[1][12] = new Array(1.10,2.30,3.95,5.98,8.34,10.86,13.18,15.29,15.33,13.46,10.38,6.80,3.63,1.66,0.58,0.12,0.00,0.00,0.00);
uv[2][12] = new Array(1.05,2.24,3.90,5.98,8.39,10.94,13.30,15.42,15.47,13.64,10.57,6.95,3.73,1.73,0.62,0.13,0.00,0.00,0.00);
uv[3][12] = new Array(0.96,2.13,3.79,5.89,8.35,10.96,13.37,15.53,15.63,13.88,10.85,7.19,3.91,1.85,0.69,0.16,0.00,0.00,0.00);
uv[4][12] = new Array(0.84,1.96,3.60,5.72,8.22,10.90,13.39,15.60,15.80,14.17,11.21,7.52,4.16,2.02,0.79,0.21,0.00,0.00,0.00);
uv[5][12] = new Array(0.70,1.75,3.35,5.47,8.00,10.75,13.33,15.62,15.96,14.50,11.63,7.92,4.48,2.25,0.92,0.27,0.02,0.00,0.00);
uv[6][12] = new Array(0.56,1.52,3.05,5.14,7.69,10.50,13.19,15.58,16.09,14.84,12.09,8.38,4.86,2.52,1.09,0.35,0.05,0.00,0.00);
uv[7][12] = new Array(0.42,1.27,2.71,4.74,7.29,10.16,12.95,15.45,16.17,15.18,12.58,8.88,5.29,2.84,1.30,0.46,0.09,0.00,0.00);
uv[8][12] = new Array(0.30,1.02,2.34,4.30,6.82,9.72,12.62,15.23,16.19,15.48,13.07,9.42,5.78,3.21,1.54,0.60,0.15,0.00,0.00);
uv[9][12] = new Array(0.19,0.79,1.97,3.81,6.28,9.19,12.18,14.90,16.12,15.72,13.54,9.97,6.30,3.63,1.83,0.77,0.22,0.01,0.00);
uv[10][12] = new Array(0.10,0.55,1.56,3.24,5.60,8.48,11.56,14.41,15.94,15.92,14.03,10.60,6.93,4.15,2.21,1.00,0.34,0.05,0.00);
uv[11][12] = new Array(0.04,0.38,1.23,2.75,4.98,7.81,10.94,13.87,15.66,15.98,14.38,11.10,7.48,4.63,2.58,1.24,0.47,0.10,0.00);
uv[12][12] = new Array(0.00,0.25,0.93,2.28,4.36,7.10,10.24,13.23,15.28,15.94,14.65,11.56,8.02,5.12,2.97,1.52,0.63,0.17,0.00);
uv[13][12] = new Array(0.00,0.15,0.69,1.84,3.75,6.38,9.49,12.53,14.80,15.81,14.82,11.96,8.55,5.62,3.38,1.82,0.82,0.27,0.03);
uv[14][12] = new Array(0.00,0.08,0.49,1.46,3.18,5.66,8.72,11.78,14.26,15.57,14.91,12.30,9.04,6.12,3.81,2.15,1.04,0.38,0.07);
uv[15][12] = new Array(0.00,0.03,0.33,1.14,2.66,4.97,7.94,10.99,13.65,15.26,14.90,12.56,9.49,6.60,4.24,2.49,1.28,0.52,0.13);
uv[16][12] = new Array(0.00,0.00,0.22,0.87,2.20,4.33,7.19,10.21,13.01,14.88,14.82,12.76,9.90,7.05,4.67,2.84,1.54,0.68,0.20);
uv[17][12] = new Array(0.00,0.00,0.13,0.65,1.80,3.75,6.48,9.45,12.36,14.46,14.67,12.89,10.27,7.49,5.09,3.20,1.81,0.86,0.29);
uv[18][12] = new Array(0.00,0.00,0.08,0.49,1.47,3.24,5.83,8.74,11.72,14.01,14.48,12.97,10.59,7.89,5.49,3.56,2.09,1.04,0.39);
uv[19][12] = new Array(0.00,0.00,0.04,0.36,1.20,2.80,5.24,8.08,11.12,13.56,14.26,13.01,10.87,8.26,5.87,3.90,2.36,1.24,0.50);
uv[20][12] = new Array(0.00,0.00,0.01,0.27,0.99,2.44,4.74,7.50,10.57,13.14,14.03,13.02,11.12,8.60,6.23,4.23,2.63,1.43,0.62);
uv[21][12] = new Array(0.00,0.00,0.00,0.21,0.83,2.15,4.32,7.01,10.09,12.76,13.81,13.03,11.34,8.91,6.57,4.54,2.89,1.62,0.73);
uv[22][12] = new Array(0.00,0.00,0.00,0.16,0.71,1.92,3.98,6.60,9.69,12.44,13.62,13.02,11.54,9.20,6.87,4.82,3.12,1.79,0.83);
uv[23][12] = new Array(0.00,0.00,0.00,0.13,0.63,1.75,3.72,6.28,9.38,12.18,13.47,13.03,11.72,9.45,7.14,5.06,3.32,1.93,0.92);
uv[24][12] = new Array(0.00,0.00,0.00,0.11,0.57,1.63,3.54,6.06,9.16,12.00,13.37,13.06,11.89,9.68,7.37,5.27,3.48,2.05,0.99);
uv[25][12] = new Array(0.00,0.00,0.00,0.10,0.54,1.57,3.43,5.93,9.04,11.91,13.33,13.11,12.05,9.88,7.57,5.43,3.60,2.13,1.04);
uv[26][12] = new Array(0.00,0.00,0.00,0.10,0.53,1.54,3.39,5.89,9.02,11.90,13.34,13.18,12.20,10.05,7.72,5.55,3.68,2.16,1.05);
uv[27][12] = new Array(0.00,0.00,0.00,0.11,0.55,1.57,3.42,5.93,9.09,11.98,13.41,13.28,12.35,10.18,7.83,5.61,3.70,2.16,1.03);
uv[28][12] = new Array(0.00,0.00,0.00,0.13,0.59,1.63,3.51,6.07,9.26,12.14,13.54,13.40,12.47,10.27,7.88,5.62,3.67,2.11,0.98);
uv[29][12] = new Array(0.00,0.00,0.00,0.15,0.65,1.74,3.67,6.28,9.52,12.38,13.72,13.54,12.57,10.32,7.87,5.56,3.58,2.01,0.91);
uv[30][12] = new Array(0.00,0.00,0.00,0.19,0.73,1.89,3.89,6.58,9.86,12.68,13.93,13.68,12.63,10.31,7.79,5.44,3.43,1.87,0.81);
uv[31][12] = new Array(0.00,0.00,0.02,0.24,0.85,2.09,4.18,6.95,10.28,13.04,14.16,13.80,12.64,10.23,7.65,5.25,3.23,1.70,0.69);
uv[32][12] = new Array(0.00,0.00,0.04,0.31,1.00,2.33,4.52,7.39,10.75,13.43,14.40,13.90,12.59,10.08,7.42,4.99,2.99,1.50,0.57);
uv[33][12] = new Array(0.00,0.00,0.07,0.41,1.18,2.62,4.92,7.89,11.27,13.84,14.63,13.96,12.47,9.84,7.12,4.67,2.70,1.29,0.44);
uv[34][12] = new Array(0.00,0.00,0.12,0.52,1.40,2.96,5.38,8.44,11.83,14.25,14.83,13.95,12.26,9.52,6.75,4.30,2.38,1.07,0.32);
uv[35][12] = new Array(0.00,0.00,0.18,0.67,1.66,3.34,5.87,9.02,12.39,14.63,14.97,13.87,11.96,9.11,6.30,3.89,2.05,0.85,0.22);
uv[36][12] = new Array(0.00,0.03,0.27,0.85,1.95,3.76,6.40,9.63,12.94,14.97,15.05,13.71,11.56,8.62,5.80,3.44,1.72,0.65,0.14);
uv[37][12] = new Array(0.00,0.07,0.38,1.07,2.29,4.22,6.96,10.24,13.47,15.25,15.04,13.46,11.07,8.05,5.25,2.98,1.39,0.47,0.07);
uv[38][12] = new Array(0.00,0.13,0.52,1.32,2.67,4.72,7.53,10.85,13.95,15.45,14.94,13.10,10.49,7.43,4.67,2.53,1.09,0.32,0.03);
uv[39][12] = new Array(0.01,0.20,0.69,1.60,3.07,5.23,8.10,11.43,14.37,15.56,14.75,12.66,9.85,6.76,4.09,2.09,0.83,0.20,0.00);
uv[40][12] = new Array(0.04,0.30,0.89,1.92,3.51,5.75,8.66,11.97,14.72,15.59,14.47,12.14,9.15,6.07,3.52,1.69,0.61,0.12,0.00);
uv[41][12] = new Array(0.09,0.43,1.12,2.27,3.96,6.29,9.20,12.47,14.98,15.52,14.11,11.56,8.42,5.39,2.98,1.33,0.43,0.06,0.00);
uv[42][12] = new Array(0.15,0.58,1.38,2.64,4.43,6.81,9.71,12.91,15.17,15.37,13.68,10.93,7.68,4.74,2.48,1.03,0.29,0.02,0.00);
uv[43][12] = new Array(0.24,0.76,1.67,3.03,4.90,7.33,10.19,13.29,15.29,15.15,13.20,10.28,6.97,4.13,2.05,0.78,0.18,0.00,0.00);
uv[44][12] = new Array(0.34,0.96,1.97,3.43,5.38,7.83,10.64,13.62,15.34,14.88,12.70,9.63,6.29,3.58,1.68,0.59,0.11,0.00,0.00);
uv[45][12] = new Array(0.45,1.17,2.28,3.83,5.84,8.30,11.04,13.90,15.34,14.59,12.20,9.02,5.68,3.10,1.37,0.43,0.06,0.00,0.00);
uv[46][12] = new Array(0.58,1.39,2.59,4.22,6.28,8.75,11.41,14.14,15.30,14.28,11.72,8.45,5.13,2.69,1.12,0.32,0.03,0.00,0.00);
uv[47][12] = new Array(0.71,1.60,2.90,4.60,6.70,9.17,11.74,14.34,15.25,13.99,11.29,7.95,4.67,2.35,0.93,0.24,0.00,0.00,0.00);
uv[48][12] = new Array(0.83,1.81,3.18,4.95,7.09,9.55,12.05,14.52,15.19,13.74,10.91,7.52,4.29,2.09,0.79,0.18,0.00,0.00,0.00);
uv[49][12] = new Array(0.95,1.99,3.43,5.26,7.44,9.89,12.32,14.68,15.15,13.54,10.62,7.19,3.99,1.89,0.68,0.15,0.00,0.00,0.00);
uv[50][12] = new Array(1.04,2.14,3.64,5.53,7.75,10.20,12.57,14.83,15.14,13.40,10.41,6.94,3.78,1.75,0.61,0.12,0.00,0.00,0.00);
uv[51][12] = new Array(1.09,2.24,3.80,5.74,8.00,10.46,12.79,14.98,15.16,13.34,10.30,6.80,3.65,1.67,0.58,0.11,0.00,0.00,0.00);
uv[52][12] = new Array(1.12,2.30,3.90,5.89,8.19,10.67,12.98,15.13,15.22,13.36,10.29,6.75,3.60,1.64,0.57,0.11,0.00,0.00,0.00);
uv[53][12] = new Array(1.10,2.30,3.93,5.96,8.31,10.82,13.15,15.27,15.33,13.46,10.38,6.81,3.63,1.66,0.58,0.12,0.00,0.00,0.00);
uv[1][13] = new Array(1.10,2.25,3.81,5.72,7.92,10.24,12.36,14.28,14.24,12.43,9.52,6.19,3.27,1.48,0.51,0.10,0.00,0.00,0.00);
uv[2][13] = new Array(1.05,2.20,3.78,5.74,8.00,10.39,12.57,14.51,14.49,12.71,9.80,6.40,3.41,1.57,0.56,0.12,0.00,0.00,0.00);
uv[3][13] = new Array(0.96,2.09,3.68,5.68,8.00,10.46,12.71,14.71,14.75,13.05,10.15,6.70,3.62,1.70,0.63,0.15,0.00,0.00,0.00);
uv[4][13] = new Array(0.84,1.93,3.51,5.53,7.91,10.44,12.79,14.86,15.00,13.41,10.56,7.06,3.89,1.88,0.73,0.19,0.00,0.00,0.00);
uv[5][13] = new Array(0.70,1.72,3.27,5.29,7.71,10.33,12.77,14.93,15.22,13.79,11.02,7.48,4.21,2.10,0.86,0.25,0.02,0.00,0.00);
uv[6][13] = new Array(0.56,1.49,2.97,4.98,7.42,10.10,12.66,14.92,15.38,14.15,11.50,7.94,4.59,2.37,1.02,0.33,0.04,0.00,0.00);
uv[7][13] = new Array(0.42,1.25,2.64,4.59,7.03,9.77,12.43,14.80,15.46,14.48,11.98,8.44,5.02,2.69,1.22,0.43,0.08,0.00,0.00);
uv[8][13] = new Array(0.30,1.00,2.27,4.15,6.56,9.32,12.08,14.56,15.46,14.75,12.44,8.95,5.48,3.04,1.46,0.56,0.14,0.00,0.00);
uv[9][13] = new Array(0.19,0.77,1.91,3.67,6.01,8.78,11.63,14.20,15.34,14.94,12.85,9.45,5.96,3.43,1.73,0.72,0.21,0.01,0.00);
uv[10][13] = new Array(0.10,0.54,1.50,3.09,5.32,8.06,10.97,13.66,15.09,15.06,13.26,10.01,6.54,3.92,2.09,0.95,0.32,0.05,0.00);
uv[11][13] = new Array(0.04,0.37,1.17,2.60,4.70,7.37,10.30,13.06,14.74,15.04,13.53,10.44,7.03,4.35,2.43,1.18,0.45,0.10,0.00);
uv[12][13] = new Array(0.00,0.24,0.88,2.14,4.08,6.64,9.57,12.38,14.29,14.91,13.70,10.82,7.51,4.80,2.79,1.43,0.60,0.17,0.00);
uv[13][13] = new Array(0.00,0.14,0.64,1.71,3.48,5.91,8.80,11.63,13.75,14.69,13.79,11.14,7.97,5.25,3.17,1.71,0.78,0.26,0.03);
uv[14][13] = new Array(0.00,0.07,0.45,1.34,2.91,5.19,8.01,10.84,13.15,14.38,13.79,11.39,8.39,5.69,3.56,2.02,0.99,0.37,0.07);
uv[15][13] = new Array(0.00,0.02,0.30,1.03,2.41,4.52,7.24,10.04,12.50,14.01,13.71,11.58,8.78,6.12,3.95,2.34,1.21,0.50,0.13);
uv[16][13] = new Array(0.00,0.00,0.19,0.77,1.97,3.90,6.49,9.26,11.84,13.59,13.57,11.72,9.13,6.53,4.35,2.67,1.46,0.66,0.20);
uv[17][13] = new Array(0.00,0.00,0.11,0.57,1.59,3.34,5.81,8.52,11.19,13.14,13.39,11.81,9.45,6.92,4.73,3.00,1.72,0.83,0.29);
uv[18][13] = new Array(0.00,0.00,0.06,0.42,1.29,2.86,5.19,7.83,10.57,12.69,13.18,11.86,9.73,7.29,5.11,3.34,1.98,1.01,0.39);
uv[19][13] = new Array(0.00,0.00,0.03,0.31,1.04,2.46,4.64,7.21,9.99,12.27,12.97,11.89,9.99,7.64,5.47,3.67,2.25,1.20,0.50);
uv[20][13] = new Array(0.00,0.00,0.01,0.23,0.85,2.13,4.18,6.68,9.49,11.88,12.76,11.91,10.23,7.96,5.81,3.98,2.51,1.39,0.62);
uv[21][13] = new Array(0.00,0.00,0.00,0.17,0.71,1.87,3.81,6.24,9.06,11.54,12.58,11.93,10.45,8.27,6.14,4.28,2.76,1.57,0.73);
uv[22][13] = new Array(0.00,0.00,0.00,0.13,0.61,1.67,3.51,5.88,8.72,11.27,12.43,11.96,10.66,8.55,6.44,4.55,2.98,1.74,0.84);
uv[23][13] = new Array(0.00,0.00,0.00,0.11,0.54,1.53,3.29,5.62,8.46,11.08,12.34,12.01,10.86,8.82,6.71,4.80,3.18,1.88,0.93);
uv[24][13] = new Array(0.00,0.00,0.00,0.09,0.49,1.43,3.14,5.45,8.30,10.96,12.29,12.08,11.06,9.06,6.95,5.01,3.35,2.00,0.99);
uv[25][13] = new Array(0.00,0.00,0.00,0.08,0.47,1.38,3.06,5.36,8.24,10.93,12.30,12.17,11.25,9.28,7.16,5.18,3.47,2.08,1.04);
uv[26][13] = new Array(0.00,0.00,0.00,0.09,0.47,1.37,3.05,5.35,8.26,10.97,12.37,12.29,11.44,9.47,7.32,5.30,3.55,2.12,1.05);
uv[27][13] = new Array(0.00,0.00,0.00,0.09,0.48,1.40,3.09,5.42,8.37,11.09,12.49,12.43,11.61,9.62,7.44,5.37,3.57,2.11,1.03);
uv[28][13] = new Array(0.00,0.00,0.00,0.11,0.52,1.47,3.20,5.57,8.56,11.28,12.64,12.57,11.75,9.73,7.50,5.39,3.55,2.06,0.98);
uv[29][13] = new Array(0.00,0.00,0.00,0.13,0.58,1.58,3.36,5.79,8.82,11.53,12.83,12.72,11.86,9.78,7.50,5.33,3.46,1.97,0.91);
uv[30][13] = new Array(0.00,0.00,0.00,0.17,0.66,1.72,3.57,6.07,9.15,11.83,13.04,12.86,11.92,9.77,7.42,5.21,3.32,1.83,0.81);
uv[31][13] = new Array(0.00,0.00,0.01,0.22,0.77,1.90,3.84,6.42,9.54,12.15,13.25,12.96,11.92,9.68,7.27,5.02,3.12,1.66,0.69);
uv[32][13] = new Array(0.00,0.00,0.03,0.28,0.90,2.13,4.15,6.82,9.96,12.50,13.45,13.02,11.84,9.51,7.04,4.76,2.87,1.47,0.56);
uv[33][13] = new Array(0.00,0.00,0.06,0.37,1.07,2.39,4.52,7.26,10.42,12.84,13.62,13.03,11.68,9.25,6.72,4.44,2.59,1.25,0.44);
uv[34][13] = new Array(0.00,0.00,0.11,0.47,1.27,2.69,4.92,7.74,10.88,13.15,13.73,12.96,11.42,8.90,6.33,4.06,2.27,1.03,0.32);
uv[35][13] = new Array(0.00,0.00,0.17,0.61,1.50,3.03,5.35,8.24,11.34,13.43,13.78,12.80,11.06,8.45,5.87,3.64,1.94,0.82,0.22);
uv[36][13] = new Array(0.00,0.03,0.24,0.77,1.77,3.41,5.81,8.74,11.78,13.65,13.75,12.55,10.61,7.93,5.35,3.20,1.61,0.62,0.14);
uv[37][13] = new Array(0.00,0.06,0.35,0.97,2.07,3.81,6.28,9.25,12.18,13.81,13.64,12.21,10.06,7.33,4.79,2.74,1.29,0.44,0.07);
uv[38][13] = new Array(0.00,0.12,0.48,1.19,2.40,4.24,6.76,9.74,12.53,13.88,13.43,11.79,9.44,6.69,4.22,2.29,1.00,0.30,0.03);
uv[39][13] = new Array(0.01,0.19,0.63,1.45,2.76,4.68,7.24,10.20,12.82,13.88,13.15,11.28,8.77,6.02,3.64,1.87,0.75,0.19,0.00);
uv[40][13] = new Array(0.04,0.29,0.82,1.74,3.15,5.14,7.71,10.63,13.05,13.80,12.79,10.71,8.06,5.34,3.09,1.49,0.54,0.10,0.00);
uv[41][13] = new Array(0.09,0.41,1.03,2.05,3.55,5.60,8.16,11.02,13.21,13.65,12.38,10.11,7.34,4.69,2.58,1.16,0.37,0.05,0.00);
uv[42][13] = new Array(0.15,0.55,1.28,2.39,3.98,6.07,8.60,11.38,13.32,13.45,11.92,9.48,6.63,4.07,2.12,0.88,0.24,0.01,0.00);
uv[43][13] = new Array(0.24,0.72,1.54,2.75,4.41,6.53,9.02,11.70,13.39,13.20,11.44,8.85,5.96,3.51,1.73,0.65,0.15,0.00,0.00);
uv[44][13] = new Array(0.34,0.91,1.83,3.12,4.84,6.99,9.42,11.99,13.42,12.94,10.97,8.26,5.35,3.01,1.40,0.48,0.08,0.00,0.00);
uv[45][13] = new Array(0.45,1.12,2.12,3.50,5.28,7.43,9.80,12.25,13.43,12.68,10.52,7.71,4.80,2.59,1.13,0.35,0.04,0.00,0.00);
uv[46][13] = new Array(0.58,1.33,2.42,3.88,5.70,7.86,10.17,12.50,13.43,12.44,10.12,7.22,4.33,2.24,0.92,0.25,0.01,0.00,0.00);
uv[47][13] = new Array(0.71,1.54,2.72,4.25,6.12,8.28,10.52,12.74,13.44,12.23,9.77,6.81,3.95,1.96,0.76,0.19,0.00,0.00,0.00);
uv[48][13] = new Array(0.83,1.74,3.00,4.59,6.51,8.68,10.86,12.98,13.48,12.08,9.51,6.48,3.64,1.75,0.64,0.14,0.00,0.00,0.00);
uv[49][13] = new Array(0.95,1.93,3.25,4.91,6.88,9.05,11.18,13.22,13.55,12.00,9.32,6.24,3.42,1.59,0.56,0.11,0.00,0.00,0.00);
uv[50][13] = new Array(1.04,2.08,3.47,5.19,7.21,9.40,11.50,13.48,13.65,11.99,9.23,6.09,3.28,1.49,0.51,0.10,0.00,0.00,0.00);
uv[51][13] = new Array(1.09,2.18,3.64,5.42,7.49,9.72,11.80,13.73,13.81,12.06,9.23,6.03,3.20,1.44,0.49,0.09,0.00,0.00,0.00);
uv[52][13] = new Array(1.12,2.24,3.75,5.60,7.72,9.99,12.08,13.99,14.00,12.20,9.33,6.07,3.21,1.44,0.49,0.09,0.00,0.00,0.00);
uv[53][13] = new Array(1.10,2.25,3.79,5.70,7.89,10.21,12.33,14.25,14.23,12.42,9.52,6.19,3.28,1.48,0.51,0.10,0.00,0.00,0.00);
uv[1][14] = new Array(1.10,2.10,3.39,4.94,6.66,8.43,9.98,11.32,11.08,9.47,7.09,4.49,2.30,1.00,0.32,0.05,0.00,0.00,0.00);
uv[2][14] = new Array(1.05,2.05,3.37,4.97,6.76,8.60,10.22,11.60,11.38,9.80,7.39,4.71,2.44,1.08,0.36,0.06,0.00,0.00,0.00);
uv[3][14] = new Array(0.96,1.95,3.29,4.92,6.78,8.69,10.39,11.83,11.68,10.15,7.74,5.00,2.64,1.20,0.42,0.09,0.00,0.00,0.00);
uv[4][14] = new Array(0.84,1.79,3.13,4.79,6.70,8.69,10.48,12.00,11.94,10.51,8.14,5.33,2.87,1.36,0.51,0.12,0.00,0.00,0.00);
uv[5][14] = new Array(0.70,1.60,2.90,4.57,6.52,8.59,10.47,12.08,12.16,10.86,8.55,5.70,3.16,1.55,0.61,0.17,0.00,0.00,0.00);
uv[6][14] = new Array(0.56,1.38,2.63,4.28,6.25,8.38,10.36,12.07,12.30,11.19,8.97,6.11,3.48,1.77,0.75,0.23,0.02,0.00,0.00);
uv[7][14] = new Array(0.42,1.15,2.31,3.92,5.89,8.06,10.14,11.94,12.36,11.46,9.37,6.52,3.83,2.03,0.91,0.31,0.05,0.00,0.00);
uv[8][14] = new Array(0.30,0.91,1.98,3.51,5.44,7.64,9.80,11.70,12.32,11.66,9.74,6.94,4.21,2.32,1.10,0.42,0.10,0.00,0.00);
uv[9][14] = new Array(0.19,0.69,1.64,3.06,4.94,7.12,9.35,11.34,12.17,11.77,10.05,7.34,4.60,2.64,1.33,0.55,0.16,0.00,0.00);
uv[10][14] = new Array(0.10,0.48,1.26,2.54,4.30,6.45,8.72,10.80,11.88,11.80,10.35,7.77,5.06,3.03,1.62,0.74,0.25,0.04,0.00);
uv[11][14] = new Array(0.04,0.32,0.97,2.09,3.74,5.81,8.09,10.22,11.51,11.71,10.51,8.10,5.45,3.38,1.89,0.93,0.36,0.08,0.00);
uv[12][14] = new Array(0.00,0.20,0.71,1.68,3.18,5.15,7.41,9.58,11.06,11.54,10.60,8.37,5.82,3.74,2.19,1.14,0.49,0.14,0.00);
uv[13][14] = new Array(0.00,0.11,0.50,1.32,2.65,4.50,6.71,8.89,10.54,11.28,10.61,8.60,6.18,4.10,2.50,1.38,0.65,0.22,0.03);
uv[14][14] = new Array(0.00,0.05,0.34,1.00,2.17,3.88,6.01,8.18,9.97,10.97,10.56,8.77,6.51,4.46,2.83,1.63,0.82,0.33,0.07);
uv[15][14] = new Array(0.00,0.01,0.21,0.74,1.75,3.31,5.34,7.48,9.39,10.61,10.46,8.90,6.81,4.81,3.15,1.91,1.02,0.45,0.13);
uv[16][14] = new Array(0.00,0.00,0.13,0.54,1.39,2.80,4.72,6.82,8.82,10.23,10.32,9.00,7.09,5.15,3.49,2.19,1.24,0.59,0.20);
uv[17][14] = new Array(0.00,0.00,0.07,0.38,1.10,2.35,4.16,6.20,8.26,9.84,10.15,9.06,7.35,5.47,3.82,2.48,1.47,0.75,0.29);
uv[18][14] = new Array(0.00,0.00,0.03,0.27,0.86,1.98,3.66,5.64,7.76,9.47,9.98,9.11,7.59,5.79,4.14,2.78,1.71,0.92,0.39);
uv[19][14] = new Array(0.00,0.00,0.00,0.19,0.68,1.67,3.24,5.16,7.30,9.13,9.81,9.15,7.81,6.09,4.46,3.07,1.95,1.10,0.50);
uv[20][14] = new Array(0.00,0.00,0.00,0.13,0.55,1.43,2.90,4.76,6.91,8.83,9.67,9.18,8.03,6.38,4.76,3.35,2.19,1.28,0.62);
uv[21][14] = new Array(0.00,0.00,0.00,0.09,0.45,1.24,2.62,4.43,6.60,8.59,9.55,9.23,8.24,6.65,5.05,3.62,2.42,1.45,0.73);
uv[22][14] = new Array(0.00,0.00,0.00,0.07,0.38,1.10,2.41,4.17,6.36,8.41,9.48,9.29,8.45,6.92,5.33,3.88,2.63,1.61,0.84);
uv[23][14] = new Array(0.00,0.00,0.00,0.05,0.33,1.00,2.26,4.00,6.19,8.30,9.44,9.38,8.65,7.17,5.58,4.10,2.82,1.75,0.93);
uv[24][14] = new Array(0.00,0.00,0.00,0.04,0.30,0.95,2.17,3.89,6.10,8.25,9.46,9.48,8.85,7.40,5.81,4.30,2.97,1.86,0.99);
uv[25][14] = new Array(0.00,0.00,0.00,0.04,0.29,0.92,2.12,3.85,6.08,8.27,9.51,9.60,9.05,7.61,6.00,4.46,3.09,1.94,1.04);
uv[26][14] = new Array(0.00,0.00,0.00,0.04,0.29,0.92,2.13,3.87,6.13,8.35,9.61,9.73,9.23,7.79,6.16,4.58,3.16,1.97,1.05);
uv[27][14] = new Array(0.00,0.00,0.00,0.05,0.31,0.95,2.18,3.95,6.25,8.48,9.74,9.88,9.39,7.93,6.27,4.64,3.19,1.97,1.03);
uv[28][14] = new Array(0.00,0.00,0.00,0.06,0.34,1.01,2.27,4.08,6.43,8.66,9.89,10.01,9.52,8.03,6.32,4.65,3.16,1.92,0.98);
uv[29][14] = new Array(0.00,0.00,0.00,0.08,0.38,1.10,2.41,4.27,6.65,8.87,10.06,10.14,9.61,8.07,6.31,4.60,3.08,1.83,0.90);
uv[30][14] = new Array(0.00,0.00,0.00,0.10,0.45,1.21,2.58,4.50,6.92,9.11,10.22,10.24,9.64,8.03,6.22,4.47,2.94,1.70,0.80);
uv[31][14] = new Array(0.00,0.00,0.00,0.14,0.53,1.35,2.79,4.77,7.22,9.36,10.37,10.29,9.60,7.93,6.06,4.29,2.75,1.54,0.69);
uv[32][14] = new Array(0.00,0.00,0.01,0.19,0.63,1.53,3.04,5.08,7.55,9.61,10.49,10.29,9.48,7.74,5.83,4.03,2.51,1.35,0.56);
uv[33][14] = new Array(0.00,0.00,0.04,0.25,0.76,1.73,3.32,5.41,7.88,9.83,10.56,10.23,9.28,7.46,5.51,3.72,2.24,1.14,0.44);
uv[34][14] = new Array(0.00,0.00,0.07,0.34,0.91,1.96,3.62,5.76,8.20,10.03,10.58,10.09,8.99,7.09,5.13,3.36,1.94,0.93,0.32);
uv[35][14] = new Array(0.00,0.00,0.12,0.44,1.09,2.22,3.94,6.12,8.51,10.17,10.53,9.87,8.61,6.65,4.69,2.97,1.64,0.73,0.22);
uv[36][14] = new Array(0.00,0.01,0.18,0.57,1.30,2.50,4.28,6.48,8.79,10.26,10.40,9.56,8.14,6.14,4.20,2.56,1.33,0.54,0.14);
uv[37][14] = new Array(0.00,0.05,0.26,0.72,1.53,2.81,4.63,6.83,9.03,10.29,10.20,9.18,7.61,5.59,3.69,2.15,1.05,0.38,0.07);
uv[38][14] = new Array(0.00,0.09,0.37,0.90,1.79,3.13,4.98,7.17,9.23,10.25,9.94,8.74,7.02,5.00,3.18,1.75,0.79,0.25,0.03);
uv[39][14] = new Array(0.01,0.16,0.50,1.11,2.07,3.47,5.33,7.48,9.39,10.16,9.61,8.24,6.40,4.40,2.68,1.39,0.57,0.15,0.00);
uv[40][14] = new Array(0.04,0.24,0.66,1.34,2.38,3.83,5.68,7.78,9.51,10.01,9.25,7.71,5.78,3.82,2.21,1.07,0.39,0.08,0.00);
uv[41][14] = new Array(0.09,0.35,0.84,1.61,2.71,4.19,6.03,8.06,9.58,9.83,8.85,7.17,5.16,3.28,1.80,0.80,0.26,0.03,0.00);
uv[42][14] = new Array(0.15,0.48,1.05,1.89,3.05,4.56,6.36,8.31,9.63,9.62,8.44,6.63,4.59,2.78,1.44,0.59,0.16,0.00,0.00);
uv[43][14] = new Array(0.24,0.64,1.28,2.19,3.41,4.94,6.70,8.56,9.66,9.40,8.03,6.12,4.05,2.34,1.13,0.42,0.09,0.00,0.00);
uv[44][14] = new Array(0.34,0.81,1.53,2.51,3.78,5.32,7.03,8.79,9.68,9.19,7.66,5.65,3.59,1.97,0.89,0.29,0.04,0.00,0.00);
uv[45][14] = new Array(0.45,1.01,1.80,2.84,4.15,5.70,7.36,9.02,9.71,9.00,7.32,5.24,3.18,1.67,0.70,0.20,0.01,0.00,0.00);
uv[46][14] = new Array(0.58,1.21,2.07,3.18,4.53,6.08,7.69,9.26,9.76,8.85,7.03,4.89,2.85,1.42,0.56,0.14,0.00,0.00,0.00);
uv[47][14] = new Array(0.71,1.41,2.34,3.51,4.90,6.46,8.02,9.51,9.83,8.75,6.82,4.61,2.59,1.23,0.45,0.10,0.00,0.00,0.00);
uv[48][14] = new Array(0.84,1.60,2.60,3.83,5.27,6.84,8.36,9.78,9.94,8.70,6.67,4.41,2.39,1.10,0.38,0.07,0.00,0.00,0.00);
uv[49][14] = new Array(0.95,1.78,2.84,4.13,5.62,7.21,8.70,10.06,10.08,8.72,6.59,4.28,2.26,1.00,0.33,0.05,0.00,0.00,0.00);
uv[50][14] = new Array(1.04,1.92,3.05,4.40,5.94,7.55,9.04,10.36,10.28,8.81,6.60,4.22,2.19,0.95,0.30,0.04,0.00,0.00,0.00);
uv[51][14] = new Array(1.09,2.03,3.22,4.63,6.22,7.88,9.36,10.67,10.51,8.97,6.69,4.24,2.17,0.93,0.29,0.04,0.00,0.00,0.00);
uv[52][14] = new Array(1.12,2.09,3.33,4.81,6.46,8.16,9.67,10.99,10.77,9.19,6.85,4.33,2.21,0.95,0.30,0.04,0.00,0.00,0.00);
uv[53][14] = new Array(1.10,2.09,3.38,4.92,6.63,8.40,9.95,11.29,11.07,9.46,7.08,4.49,2.30,1.00,0.32,0.05,0.00,0.00,0.00);
uv[1][15] = new Array(1.10,1.87,2.79,3.82,4.91,5.95,6.78,7.39,6.96,5.70,4.06,2.43,1.17,0.47,0.13,0.00,0.00,0.00,0.00);
uv[2][15] = new Array(1.05,1.82,2.77,3.85,4.99,6.10,6.98,7.64,7.23,5.98,4.31,2.61,1.28,0.53,0.15,0.01,0.00,0.00,0.00);
uv[3][15] = new Array(0.96,1.73,2.69,3.81,5.01,6.18,7.13,7.85,7.48,6.27,4.59,2.83,1.42,0.61,0.19,0.02,0.00,0.00,0.00);
uv[4][15] = new Array(0.84,1.58,2.55,3.69,4.93,6.17,7.20,7.99,7.70,6.56,4.89,3.07,1.59,0.71,0.24,0.04,0.00,0.00,0.00);
uv[5][15] = new Array(0.70,1.40,2.35,3.50,4.78,6.07,7.18,8.05,7.87,6.82,5.20,3.35,1.79,0.84,0.31,0.07,0.00,0.00,0.00);
uv[6][15] = new Array(0.56,1.20,2.10,3.24,4.53,5.88,7.06,8.01,7.96,7.05,5.50,3.63,2.01,0.99,0.40,0.11,0.00,0.00,0.00);
uv[7][15] = new Array(0.42,0.99,1.83,2.92,4.21,5.59,6.85,7.88,7.98,7.23,5.77,3.92,2.25,1.16,0.51,0.16,0.02,0.00,0.00);
uv[8][15] = new Array(0.30,0.77,1.53,2.57,3.83,5.22,6.54,7.65,7.91,7.34,6.02,4.20,2.51,1.36,0.64,0.24,0.05,0.00,0.00);
uv[9][15] = new Array(0.19,0.58,1.24,2.19,3.40,4.78,6.15,7.33,7.75,7.39,6.21,4.47,2.77,1.58,0.79,0.33,0.09,0.00,0.00);
uv[10][15] = new Array(0.10,0.38,0.92,1.76,2.88,4.22,5.61,6.87,7.47,7.35,6.38,4.76,3.09,1.84,0.99,0.46,0.16,0.02,0.00);
uv[11][15] = new Array(0.04,0.25,0.68,1.40,2.43,3.71,5.10,6.39,7.15,7.24,6.47,4.97,3.35,2.09,1.18,0.59,0.24,0.05,0.00);
uv[12][15] = new Array(0.00,0.15,0.48,1.08,2.00,3.20,4.56,5.88,6.78,7.07,6.50,5.14,3.60,2.34,1.40,0.75,0.34,0.11,0.00);
uv[13][15] = new Array(0.00,0.07,0.32,0.81,1.60,2.71,4.03,5.35,6.36,6.85,6.48,5.29,3.84,2.60,1.62,0.93,0.46,0.17,0.03);
uv[14][15] = new Array(0.00,0.03,0.20,0.58,1.26,2.25,3.51,4.82,5.93,6.59,6.42,5.40,4.07,2.85,1.86,1.12,0.60,0.26,0.07);
uv[15][15] = new Array(0.00,0.00,0.11,0.41,0.97,1.85,3.03,4.32,5.51,6.32,6.33,5.49,4.29,3.11,2.11,1.33,0.76,0.37,0.13);
uv[16][15] = new Array(0.00,0.00,0.06,0.28,0.73,1.51,2.61,3.85,5.10,6.04,6.22,5.55,4.49,3.36,2.36,1.56,0.94,0.49,0.20);
uv[17][15] = new Array(0.00,0.00,0.02,0.18,0.55,1.22,2.23,3.44,4.72,5.77,6.11,5.61,4.68,3.60,2.62,1.79,1.13,0.64,0.29);
uv[18][15] = new Array(0.00,0.00,0.00,0.11,0.41,0.99,1.92,3.08,4.38,5.53,6.01,5.66,4.87,3.85,2.87,2.03,1.34,0.79,0.39);
uv[19][15] = new Array(0.00,0.00,0.00,0.07,0.31,0.81,1.66,2.78,4.10,5.32,5.92,5.71,5.05,4.09,3.13,2.27,1.54,0.95,0.50);
uv[20][15] = new Array(0.00,0.00,0.00,0.04,0.23,0.67,1.46,2.53,3.86,5.14,5.85,5.77,5.23,4.32,3.38,2.50,1.75,1.12,0.62);
uv[21][15] = new Array(0.00,0.00,0.00,0.02,0.18,0.57,1.30,2.34,3.68,5.01,5.80,5.83,5.41,4.55,3.62,2.73,1.95,1.27,0.73);
uv[22][15] = new Array(0.00,0.00,0.00,0.00,0.15,0.50,1.19,2.20,3.54,4.92,5.79,5.92,5.59,4.77,3.85,2.95,2.13,1.42,0.84);
uv[23][15] = new Array(0.00,0.00,0.00,0.00,0.12,0.45,1.11,2.11,3.47,4.88,5.81,6.01,5.77,4.98,4.06,3.14,2.30,1.55,0.93);
uv[24][15] = new Array(0.00,0.00,0.00,0.00,0.11,0.42,1.07,2.07,3.43,4.89,5.86,6.12,5.95,5.18,4.25,3.31,2.43,1.65,0.99);
uv[25][15] = new Array(0.00,0.00,0.00,0.00,0.11,0.42,1.06,2.06,3.45,4.93,5.93,6.24,6.11,5.36,4.41,3.45,2.54,1.72,1.04);
uv[26][15] = new Array(0.00,0.00,0.00,0.00,0.11,0.42,1.07,2.09,3.51,5.01,6.03,6.36,6.26,5.50,4.54,3.55,2.60,1.76,1.05);
uv[27][15] = new Array(0.00,0.00,0.00,0.00,0.12,0.45,1.11,2.15,3.60,5.12,6.14,6.47,6.39,5.61,4.62,3.60,2.62,1.75,1.03);
uv[28][15] = new Array(0.00,0.00,0.00,0.00,0.14,0.48,1.18,2.25,3.73,5.26,6.26,6.58,6.48,5.67,4.65,3.59,2.59,1.71,0.98);
uv[29][15] = new Array(0.00,0.00,0.00,0.01,0.17,0.54,1.27,2.38,3.89,5.41,6.37,6.65,6.53,5.68,4.63,3.53,2.51,1.62,0.90);
uv[30][15] = new Array(0.00,0.00,0.00,0.03,0.20,0.61,1.38,2.53,4.06,5.56,6.47,6.70,6.52,5.63,4.53,3.41,2.38,1.50,0.80);
uv[31][15] = new Array(0.00,0.00,0.00,0.05,0.25,0.70,1.52,2.70,4.25,5.71,6.54,6.70,6.44,5.50,4.37,3.24,2.20,1.34,0.69);
uv[32][15] = new Array(0.00,0.00,0.00,0.08,0.32,0.81,1.67,2.90,4.45,5.85,6.58,6.64,6.30,5.30,4.15,3.00,1.99,1.16,0.56);
uv[33][15] = new Array(0.00,0.00,0.00,0.12,0.39,0.93,1.84,3.10,4.64,5.95,6.57,6.53,6.08,5.04,3.86,2.73,1.74,0.97,0.44);
uv[34][15] = new Array(0.00,0.00,0.03,0.17,0.49,1.08,2.03,3.31,4.81,6.02,6.50,6.35,5.79,4.70,3.52,2.41,1.48,0.78,0.32);
uv[35][15] = new Array(0.00,0.00,0.06,0.24,0.60,1.24,2.23,3.52,4.97,6.06,6.39,6.11,5.44,4.31,3.14,2.08,1.22,0.60,0.22);
uv[36][15] = new Array(0.00,0.00,0.10,0.32,0.74,1.42,2.44,3.72,5.11,6.05,6.22,5.81,5.03,3.88,2.73,1.73,0.96,0.44,0.14);
uv[37][15] = new Array(0.00,0.02,0.16,0.43,0.89,1.61,2.65,3.92,5.22,5.99,6.00,5.46,4.58,3.43,2.32,1.40,0.73,0.30,0.07);
uv[38][15] = new Array(0.00,0.06,0.23,0.55,1.06,1.83,2.87,4.11,5.30,5.90,5.75,5.08,4.11,2.97,1.93,1.10,0.53,0.19,0.03);
uv[39][15] = new Array(0.01,0.12,0.33,0.70,1.26,2.05,3.09,4.29,5.35,5.77,5.46,4.68,3.64,2.52,1.56,0.83,0.36,0.10,0.00);
uv[40][15] = new Array(0.04,0.19,0.45,0.87,1.47,2.29,3.32,4.46,5.39,5.63,5.15,4.27,3.18,2.11,1.23,0.61,0.23,0.05,0.00);
uv[41][15] = new Array(0.09,0.28,0.59,1.06,1.70,2.54,3.54,4.63,5.41,5.46,4.85,3.87,2.76,1.73,0.95,0.43,0.14,0.01,0.00);
uv[42][15] = new Array(0.15,0.39,0.76,1.27,1.95,2.80,3.77,4.79,5.42,5.30,4.55,3.50,2.37,1.41,0.72,0.29,0.07,0.00,0.00);
uv[43][15] = new Array(0.24,0.53,0.95,1.51,2.21,3.07,4.01,4.96,5.44,5.15,4.28,3.17,2.04,1.14,0.53,0.19,0.03,0.00,0.00);
uv[44][15] = new Array(0.34,0.68,1.16,1.76,2.50,3.35,4.25,5.13,5.46,5.01,4.04,2.87,1.75,0.92,0.39,0.12,0.00,0.00,0.00);
uv[45][15] = new Array(0.45,0.86,1.38,2.03,2.79,3.65,4.51,5.31,5.50,4.91,3.83,2.62,1.52,0.75,0.29,0.07,0.00,0.00,0.00);
uv[46][15] = new Array(0.58,1.04,1.61,2.30,3.09,3.95,4.77,5.51,5.57,4.85,3.68,2.43,1.34,0.62,0.22,0.04,0.00,0.00,0.00);
uv[47][15] = new Array(0.71,1.22,1.85,2.58,3.40,4.26,5.05,5.73,5.67,4.82,3.57,2.28,1.20,0.53,0.17,0.01,0.00,0.00,0.00);
uv[48][15] = new Array(0.84,1.40,2.08,2.85,3.70,4.57,5.34,5.97,5.80,4.85,3.52,2.19,1.11,0.46,0.13,0.00,0.00,0.00,0.00);
uv[49][15] = new Array(0.95,1.56,2.29,3.11,4.00,4.88,5.63,6.24,5.97,4.92,3.52,2.15,1.05,0.42,0.11,0.00,0.00,0.00,0.00);
uv[50][15] = new Array(1.04,1.70,2.48,3.35,4.27,5.19,5.93,6.52,6.18,5.05,3.58,2.15,1.03,0.41,0.10,0.00,0.00,0.00,0.00);
uv[51][15] = new Array(1.09,1.80,2.63,3.55,4.52,5.47,6.23,6.81,6.42,5.22,3.69,2.20,1.05,0.41,0.10,0.00,0.00,0.00,0.00);
uv[52][15] = new Array(1.12,1.86,2.73,3.70,4.73,5.72,6.51,7.10,6.67,5.44,3.85,2.29,1.09,0.43,0.11,0.00,0.00,0.00,0.00);
uv[53][15] = new Array(1.10,1.86,2.78,3.80,4.89,5.93,6.76,7.38,6.95,5.69,4.06,2.43,1.17,0.47,0.13,0.00,0.00,0.00,0.00);
uv[1][16] = new Array(1.10,1.59,2.11,2.62,3.10,3.48,3.69,3.73,3.25,2.44,1.58,0.85,0.35,0.11,0.00,0.00,0.00,0.00,0.00);
uv[2][16] = new Array(1.05,1.55,2.09,2.64,3.16,3.58,3.82,3.90,3.43,2.62,1.73,0.94,0.41,0.14,0.01,0.00,0.00,0.00,0.00);
uv[3][16] = new Array(0.96,1.46,2.02,2.60,3.15,3.63,3.91,4.03,3.59,2.79,1.89,1.06,0.48,0.17,0.03,0.00,0.00,0.00,0.00);
uv[4][16] = new Array(0.84,1.33,1.89,2.49,3.08,3.60,3.94,4.11,3.72,2.96,2.05,1.19,0.56,0.22,0.05,0.00,0.00,0.00,0.00);
uv[5][16] = new Array(0.70,1.17,1.72,2.33,2.95,3.51,3.90,4.13,3.81,3.11,2.22,1.34,0.66,0.28,0.09,0.00,0.00,0.00,0.00);
uv[6][16] = new Array(0.56,0.98,1.51,2.12,2.75,3.34,3.80,4.08,3.85,3.24,2.38,1.49,0.78,0.36,0.13,0.02,0.00,0.00,0.00);
uv[7][16] = new Array(0.42,0.79,1.28,1.86,2.50,3.11,3.62,3.97,3.84,3.32,2.53,1.64,0.90,0.44,0.18,0.04,0.00,0.00,0.00);
uv[8][16] = new Array(0.30,0.61,1.05,1.59,2.20,2.83,3.38,3.79,3.76,3.36,2.65,1.79,1.04,0.55,0.25,0.08,0.00,0.00,0.00);
uv[9][16] = new Array(0.19,0.44,0.81,1.30,1.89,2.51,3.09,3.55,3.63,3.36,2.75,1.93,1.18,0.66,0.33,0.13,0.03,0.00,0.00);
uv[10][16] = new Array(0.10,0.28,0.58,0.99,1.52,2.12,2.72,3.23,3.43,3.31,2.82,2.08,1.34,0.81,0.44,0.20,0.07,0.00,0.00);
uv[11][16] = new Array(0.04,0.17,0.40,0.75,1.22,1.78,2.38,2.92,3.22,3.22,2.85,2.19,1.49,0.94,0.55,0.29,0.12,0.03,0.00);
uv[12][16] = new Array(0.00,0.09,0.26,0.54,0.94,1.46,2.04,2.60,2.97,3.10,2.85,2.28,1.63,1.09,0.68,0.38,0.19,0.07,0.00);
uv[13][16] = new Array(0.00,0.04,0.16,0.37,0.71,1.17,1.72,2.28,2.72,2.96,2.83,2.36,1.77,1.24,0.82,0.50,0.27,0.12,0.03);
uv[14][16] = new Array(0.00,0.00,0.08,0.24,0.51,0.91,1.43,1.98,2.48,2.80,2.79,2.42,1.90,1.39,0.97,0.63,0.37,0.19,0.07);
uv[15][16] = new Array(0.00,0.00,0.03,0.15,0.36,0.70,1.17,1.71,2.24,2.65,2.75,2.48,2.03,1.55,1.13,0.77,0.49,0.28,0.13);
uv[16][16] = new Array(0.00,0.00,0.00,0.08,0.24,0.53,0.95,1.47,2.03,2.50,2.70,2.53,2.16,1.71,1.29,0.93,0.63,0.39,0.20);
uv[17][16] = new Array(0.00,0.00,0.00,0.04,0.16,0.40,0.77,1.27,1.84,2.37,2.65,2.57,2.28,1.88,1.47,1.10,0.78,0.51,0.29);
uv[18][16] = new Array(0.00,0.00,0.00,0.01,0.10,0.30,0.63,1.10,1.68,2.25,2.61,2.62,2.41,2.04,1.65,1.27,0.94,0.64,0.39);
uv[19][16] = new Array(0.00,0.00,0.00,0.00,0.06,0.22,0.52,0.96,1.54,2.16,2.58,2.67,2.54,2.21,1.83,1.45,1.10,0.78,0.50);
uv[20][16] = new Array(0.00,0.00,0.00,0.00,0.04,0.17,0.44,0.86,1.44,2.09,2.57,2.73,2.67,2.38,2.01,1.64,1.27,0.93,0.62);
uv[21][16] = new Array(0.00,0.00,0.00,0.00,0.02,0.14,0.38,0.79,1.37,2.04,2.57,2.80,2.80,2.54,2.19,1.81,1.43,1.07,0.73);
uv[22][16] = new Array(0.00,0.00,0.00,0.00,0.01,0.11,0.34,0.73,1.32,2.02,2.59,2.87,2.93,2.71,2.37,1.98,1.58,1.20,0.84);
uv[23][16] = new Array(0.00,0.00,0.00,0.00,0.00,0.10,0.32,0.71,1.30,2.02,2.63,2.95,3.06,2.86,2.53,2.13,1.72,1.31,0.93);
uv[24][16] = new Array(0.00,0.00,0.00,0.00,0.00,0.09,0.31,0.69,1.30,2.04,2.68,3.04,3.19,3.00,2.67,2.26,1.84,1.41,0.99);
uv[25][16] = new Array(0.00,0.00,0.00,0.00,0.00,0.09,0.31,0.70,1.32,2.09,2.74,3.13,3.31,3.13,2.79,2.37,1.92,1.47,1.04);
uv[26][16] = new Array(0.00,0.00,0.00,0.00,0.00,0.10,0.32,0.72,1.36,2.14,2.81,3.21,3.41,3.22,2.87,2.44,1.97,1.50,1.05);
uv[27][16] = new Array(0.00,0.00,0.00,0.00,0.00,0.11,0.34,0.76,1.42,2.21,2.88,3.28,3.48,3.29,2.92,2.47,1.98,1.49,1.03);
uv[28][16] = new Array(0.00,0.00,0.00,0.00,0.01,0.12,0.37,0.81,1.49,2.29,2.95,3.34,3.53,3.32,2.93,2.46,1.95,1.45,0.98);
uv[29][16] = new Array(0.00,0.00,0.00,0.00,0.02,0.15,0.41,0.87,1.56,2.36,3.01,3.37,3.54,3.30,2.89,2.39,1.87,1.37,0.90);
uv[30][16] = new Array(0.00,0.00,0.00,0.00,0.04,0.18,0.47,0.94,1.65,2.44,3.04,3.37,3.50,3.23,2.79,2.28,1.76,1.25,0.80);
uv[31][16] = new Array(0.00,0.00,0.00,0.00,0.06,0.22,0.53,1.02,1.73,2.50,3.05,3.33,3.41,3.11,2.65,2.13,1.60,1.11,0.69);
uv[32][16] = new Array(0.00,0.00,0.00,0.00,0.09,0.26,0.60,1.11,1.82,2.54,3.04,3.25,3.27,2.93,2.46,1.93,1.42,0.95,0.56);
uv[33][16] = new Array(0.00,0.00,0.00,0.02,0.12,0.32,0.68,1.20,1.89,2.57,2.99,3.13,3.08,2.71,2.22,1.70,1.21,0.78,0.44);
uv[34][16] = new Array(0.00,0.00,0.00,0.05,0.17,0.39,0.76,1.29,1.96,2.57,2.90,2.97,2.85,2.45,1.96,1.46,1.00,0.61,0.32);
uv[35][16] = new Array(0.00,0.00,0.01,0.08,0.22,0.46,0.85,1.38,2.01,2.54,2.79,2.78,2.59,2.16,1.68,1.20,0.79,0.46,0.22);
uv[36][16] = new Array(0.00,0.00,0.03,0.12,0.29,0.55,0.95,1.47,2.05,2.50,2.65,2.56,2.30,1.86,1.39,0.96,0.59,0.32,0.14);
uv[37][16] = new Array(0.00,0.00,0.07,0.18,0.37,0.65,1.05,1.55,2.08,2.43,2.48,2.32,2.00,1.56,1.12,0.73,0.42,0.21,0.07);
uv[38][16] = new Array(0.00,0.03,0.11,0.25,0.46,0.76,1.16,1.64,2.10,2.34,2.30,2.07,1.71,1.28,0.87,0.53,0.28,0.12,0.02);
uv[39][16] = new Array(0.01,0.07,0.18,0.34,0.57,0.88,1.27,1.71,2.10,2.25,2.12,1.82,1.44,1.02,0.65,0.37,0.17,0.06,0.00);
uv[40][16] = new Array(0.04,0.13,0.26,0.44,0.69,1.01,1.39,1.79,2.10,2.15,1.94,1.59,1.18,0.79,0.47,0.24,0.10,0.01,0.00);
uv[41][16] = new Array(0.09,0.20,0.36,0.57,0.83,1.15,1.51,1.87,2.10,2.05,1.77,1.38,0.97,0.60,0.33,0.15,0.04,0.00,0.00);
uv[42][16] = new Array(0.15,0.29,0.48,0.71,0.98,1.30,1.64,1.96,2.10,1.96,1.61,1.19,0.78,0.45,0.22,0.08,0.00,0.00,0.00);
uv[43][16] = new Array(0.24,0.41,0.62,0.87,1.15,1.47,1.78,2.05,2.11,1.89,1.48,1.04,0.63,0.33,0.14,0.03,0.00,0.00,0.00);
uv[44][16] = new Array(0.34,0.54,0.78,1.05,1.34,1.65,1.93,2.15,2.13,1.83,1.37,0.91,0.51,0.24,0.09,0.01,0.00,0.00,0.00);
uv[45][16] = new Array(0.46,0.69,0.95,1.24,1.54,1.84,2.09,2.27,2.17,1.79,1.29,0.81,0.42,0.18,0.05,0.00,0.00,0.00,0.00);
uv[46][16] = new Array(0.58,0.85,1.14,1.44,1.75,2.04,2.27,2.40,2.23,1.78,1.23,0.73,0.36,0.14,0.02,0.00,0.00,0.00,0.00);
uv[47][16] = new Array(0.71,1.01,1.33,1.65,1.97,2.26,2.46,2.55,2.31,1.79,1.20,0.68,0.31,0.11,0.01,0.00,0.00,0.00,0.00);
uv[48][16] = new Array(0.84,1.17,1.52,1.86,2.20,2.48,2.66,2.72,2.42,1.84,1.20,0.66,0.28,0.09,0.00,0.00,0.00,0.00,0.00);
uv[49][16] = new Array(0.95,1.32,1.69,2.07,2.42,2.71,2.87,2.91,2.55,1.91,1.22,0.65,0.27,0.08,0.00,0.00,0.00,0.00,0.00);
uv[50][16] = new Array(1.04,1.44,1.85,2.25,2.63,2.93,3.09,3.11,2.70,2.00,1.27,0.67,0.27,0.08,0.00,0.00,0.00,0.00,0.00);
uv[51][16] = new Array(1.09,1.53,1.97,2.41,2.82,3.14,3.30,3.32,2.87,2.13,1.35,0.71,0.29,0.08,0.00,0.00,0.00,0.00,0.00);
uv[52][16] = new Array(1.12,1.58,2.06,2.53,2.97,3.32,3.50,3.52,3.05,2.27,1.45,0.76,0.31,0.09,0.00,0.00,0.00,0.00,0.00);
uv[53][16] = new Array(1.10,1.59,2.10,2.61,3.09,3.47,3.67,3.72,3.24,2.44,1.58,0.84,0.35,0.11,0.00,0.00,0.00,0.00,0.00);
uv[1][17] = new Array(1.10,1.30,1.46,1.57,1.62,1.59,1.46,1.26,0.93,0.58,0.30,0.11,0.02,0.00,0.00,0.00,0.00,0.00,0.00);
uv[2][17] = new Array(1.05,1.26,1.44,1.57,1.64,1.63,1.52,1.34,1.01,0.65,0.35,0.14,0.03,0.00,0.00,0.00,0.00,0.00,0.00);
uv[3][17] = new Array(0.95,1.18,1.38,1.53,1.63,1.64,1.56,1.40,1.08,0.72,0.40,0.18,0.05,0.00,0.00,0.00,0.00,0.00,0.00);
uv[4][17] = new Array(0.84,1.07,1.27,1.45,1.57,1.61,1.56,1.43,1.13,0.78,0.46,0.22,0.07,0.00,0.00,0.00,0.00,0.00,0.00);
uv[5][17] = new Array(0.70,0.92,1.13,1.32,1.46,1.54,1.52,1.42,1.16,0.83,0.51,0.26,0.10,0.02,0.00,0.00,0.00,0.00,0.00);
uv[6][17] = new Array(0.56,0.76,0.97,1.16,1.32,1.42,1.44,1.38,1.16,0.87,0.57,0.31,0.14,0.04,0.00,0.00,0.00,0.00,0.00);
uv[7][17] = new Array(0.42,0.60,0.79,0.98,1.15,1.27,1.33,1.31,1.14,0.89,0.61,0.36,0.18,0.07,0.01,0.00,0.00,0.00,0.00);
uv[8][17] = new Array(0.29,0.45,0.62,0.79,0.96,1.10,1.18,1.20,1.09,0.90,0.65,0.41,0.22,0.10,0.03,0.00,0.00,0.00,0.00);
uv[9][17] = new Array(0.19,0.31,0.45,0.61,0.77,0.92,1.03,1.08,1.03,0.88,0.68,0.46,0.27,0.14,0.06,0.01,0.00,0.00,0.00);
uv[10][17] = new Array(0.10,0.18,0.29,0.42,0.57,0.71,0.84,0.93,0.93,0.85,0.70,0.51,0.33,0.20,0.11,0.05,0.01,0.00,0.00);
uv[11][17] = new Array(0.04,0.10,0.18,0.29,0.41,0.55,0.68,0.79,0.83,0.81,0.71,0.55,0.38,0.25,0.15,0.08,0.03,0.00,0.00);
uv[12][17] = new Array(0.00,0.04,0.10,0.18,0.28,0.40,0.53,0.65,0.73,0.76,0.70,0.58,0.44,0.31,0.21,0.13,0.07,0.03,0.00);
uv[13][17] = new Array(0.00,0.00,0.04,0.10,0.18,0.28,0.41,0.53,0.64,0.70,0.70,0.61,0.49,0.38,0.28,0.19,0.12,0.07,0.03);
uv[14][17] = new Array(0.00,0.00,0.01,0.05,0.11,0.19,0.30,0.43,0.55,0.65,0.68,0.64,0.55,0.45,0.35,0.26,0.19,0.12,0.07);
uv[15][17] = new Array(0.00,0.00,0.00,0.01,0.05,0.12,0.22,0.34,0.47,0.60,0.67,0.67,0.61,0.53,0.44,0.35,0.27,0.19,0.13);
uv[16][17] = new Array(0.00,0.00,0.00,0.00,0.02,0.07,0.15,0.26,0.40,0.55,0.66,0.69,0.67,0.61,0.53,0.45,0.36,0.28,0.20);
uv[17][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.04,0.10,0.21,0.35,0.51,0.65,0.72,0.73,0.69,0.63,0.55,0.47,0.38,0.29);
uv[18][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.01,0.07,0.17,0.31,0.48,0.65,0.75,0.80,0.79,0.74,0.67,0.58,0.49,0.39);
uv[19][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.05,0.13,0.27,0.46,0.65,0.79,0.87,0.88,0.85,0.79,0.71,0.61,0.50);
uv[20][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.03,0.11,0.25,0.44,0.66,0.83,0.94,0.98,0.96,0.91,0.83,0.74,0.62);
uv[21][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.10,0.23,0.44,0.67,0.87,1.02,1.08,1.08,1.03,0.96,0.86,0.73);
uv[22][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.09,0.23,0.44,0.69,0.91,1.09,1.17,1.19,1.15,1.08,0.97,0.84);
uv[23][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.08,0.23,0.45,0.72,0.96,1.17,1.27,1.29,1.26,1.18,1.07,0.93);
uv[24][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.08,0.23,0.46,0.75,1.01,1.24,1.35,1.38,1.35,1.27,1.15,0.99);
uv[25][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.09,0.24,0.48,0.78,1.06,1.30,1.42,1.46,1.42,1.34,1.21,1.04);
uv[26][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.09,0.25,0.51,0.81,1.10,1.35,1.47,1.51,1.47,1.37,1.23,1.05);
uv[27][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.11,0.27,0.53,0.84,1.13,1.38,1.50,1.53,1.48,1.37,1.22,1.03);
uv[28][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.03,0.12,0.29,0.56,0.86,1.15,1.39,1.50,1.52,1.46,1.34,1.18,0.98);
uv[29][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.04,0.14,0.32,0.58,0.88,1.15,1.38,1.47,1.47,1.40,1.27,1.10,0.90);
uv[30][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.05,0.16,0.34,0.60,0.88,1.13,1.34,1.41,1.40,1.31,1.17,1.00,0.80);
uv[31][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.06,0.18,0.36,0.61,0.87,1.09,1.27,1.32,1.28,1.19,1.05,0.88,0.69);
uv[32][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.02,0.08,0.20,0.38,0.62,0.85,1.03,1.17,1.20,1.15,1.04,0.90,0.74,0.56);
uv[33][17] = new Array(0.00,0.00,0.00,0.00,0.00,0.03,0.10,0.22,0.40,0.61,0.81,0.95,1.06,1.05,0.99,0.88,0.74,0.59,0.44);
uv[34][17] = new Array(0.00,0.00,0.00,0.00,0.01,0.05,0.13,0.24,0.41,0.60,0.75,0.86,0.92,0.90,0.82,0.71,0.58,0.45,0.32);
uv[35][17] = new Array(0.00,0.00,0.00,0.00,0.02,0.07,0.15,0.27,0.42,0.57,0.69,0.76,0.78,0.74,0.65,0.55,0.43,0.32,0.22);
uv[36][17] = new Array(0.00,0.00,0.00,0.01,0.05,0.10,0.18,0.29,0.42,0.54,0.62,0.65,0.64,0.58,0.50,0.40,0.30,0.21,0.14);
uv[37][17] = new Array(0.00,0.00,0.00,0.03,0.07,0.13,0.21,0.31,0.42,0.51,0.55,0.55,0.51,0.44,0.36,0.27,0.20,0.13,0.07);
uv[38][17] = new Array(0.00,0.00,0.03,0.06,0.11,0.17,0.25,0.33,0.42,0.47,0.48,0.45,0.39,0.32,0.24,0.17,0.11,0.06,0.02);
uv[39][17] = new Array(0.01,0.03,0.07,0.11,0.15,0.21,0.28,0.35,0.41,0.43,0.41,0.36,0.29,0.22,0.15,0.10,0.05,0.02,0.00);
uv[40][17] = new Array(0.04,0.07,0.11,0.16,0.21,0.26,0.32,0.38,0.41,0.40,0.35,0.28,0.21,0.14,0.08,0.04,0.01,0.00,0.00);
uv[41][17] = new Array(0.09,0.13,0.18,0.22,0.27,0.32,0.37,0.40,0.41,0.36,0.29,0.22,0.14,0.08,0.04,0.01,0.00,0.00,0.00);
uv[42][17] = new Array(0.15,0.20,0.25,0.30,0.35,0.39,0.42,0.43,0.41,0.34,0.25,0.16,0.09,0.04,0.01,0.00,0.00,0.00,0.00);
uv[43][17] = new Array(0.24,0.30,0.35,0.40,0.44,0.47,0.48,0.47,0.41,0.32,0.21,0.13,0.06,0.01,0.00,0.00,0.00,0.00,0.00);
uv[44][17] = new Array(0.34,0.40,0.46,0.51,0.54,0.56,0.55,0.51,0.43,0.31,0.19,0.10,0.03,0.00,0.00,0.00,0.00,0.00,0.00);
uv[45][17] = new Array(0.46,0.53,0.59,0.63,0.65,0.66,0.62,0.56,0.45,0.30,0.17,0.08,0.02,0.00,0.00,0.00,0.00,0.00,0.00);
uv[46][17] = new Array(0.58,0.66,0.72,0.76,0.78,0.77,0.71,0.62,0.47,0.30,0.16,0.06,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[47][17] = new Array(0.71,0.80,0.87,0.91,0.91,0.88,0.81,0.69,0.51,0.32,0.16,0.05,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[48][17] = new Array(0.84,0.94,1.01,1.05,1.05,1.01,0.91,0.78,0.56,0.34,0.16,0.05,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[49][17] = new Array(0.95,1.07,1.15,1.19,1.19,1.14,1.03,0.87,0.62,0.37,0.17,0.05,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[50][17] = new Array(1.04,1.17,1.27,1.32,1.33,1.27,1.14,0.96,0.69,0.41,0.19,0.06,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[51][17] = new Array(1.10,1.25,1.37,1.43,1.45,1.39,1.26,1.07,0.77,0.46,0.22,0.07,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[52][17] = new Array(1.12,1.30,1.43,1.52,1.54,1.50,1.36,1.17,0.85,0.51,0.25,0.09,0.01,0.00,0.00,0.00,0.00,0.00,0.00);
uv[53][17] = new Array(1.10,1.30,1.46,1.56,1.61,1.58,1.45,1.26,0.93,0.58,0.30,0.11,0.02,0.00,0.00,0.00,0.00,0.00,0.00);
uv[1][18] = new Array(1.10,1.03,0.93,0.80,0.65,0.50,0.34,0.20,0.09,0.01,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[2][18] = new Array(1.04,1.00,0.91,0.80,0.66,0.51,0.36,0.22,0.10,0.02,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[3][18] = new Array(0.95,0.92,0.86,0.76,0.64,0.51,0.36,0.23,0.11,0.03,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[4][18] = new Array(0.84,0.82,0.77,0.70,0.60,0.48,0.35,0.23,0.12,0.04,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[5][18] = new Array(0.70,0.70,0.67,0.61,0.53,0.44,0.33,0.22,0.13,0.05,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[6][18] = new Array(0.56,0.56,0.55,0.51,0.45,0.38,0.29,0.21,0.12,0.06,0.01,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[7][18] = new Array(0.42,0.43,0.42,0.40,0.36,0.31,0.25,0.18,0.11,0.06,0.01,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[8][18] = new Array(0.29,0.31,0.31,0.30,0.27,0.24,0.20,0.15,0.10,0.06,0.02,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[9][18] = new Array(0.19,0.20,0.20,0.20,0.19,0.17,0.15,0.12,0.08,0.05,0.02,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[10][18] = new Array(0.10,0.11,0.11,0.11,0.11,0.10,0.09,0.08,0.06,0.04,0.03,0.01,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[11][18] = new Array(0.04,0.05,0.05,0.05,0.06,0.06,0.05,0.05,0.04,0.04,0.03,0.02,0.01,0.00,0.00,0.00,0.00,0.00,0.00);
uv[12][18] = new Array(0.00,0.01,0.01,0.01,0.02,0.02,0.02,0.03,0.03,0.03,0.03,0.02,0.02,0.01,0.01,0.01,0.00,0.00,0.00);
uv[13][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.01,0.02,0.03,0.03,0.03,0.03,0.03,0.03,0.03,0.03,0.03);
uv[14][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.02,0.04,0.04,0.05,0.06,0.06,0.07,0.07,0.07);
uv[15][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.02,0.04,0.06,0.08,0.09,0.10,0.11,0.12,0.13);
uv[16][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.05,0.08,0.10,0.13,0.15,0.17,0.19,0.20);
uv[17][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.06,0.10,0.13,0.17,0.21,0.24,0.27,0.29);
uv[18][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.03,0.07,0.12,0.17,0.22,0.27,0.32,0.36,0.39);
uv[19][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.03,0.08,0.14,0.21,0.28,0.34,0.40,0.46,0.50);
uv[20][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.03,0.09,0.17,0.25,0.33,0.42,0.49,0.56,0.62);
uv[21][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.04,0.11,0.19,0.29,0.39,0.49,0.58,0.67,0.73);
uv[22][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.04,0.12,0.22,0.34,0.45,0.57,0.67,0.76,0.84);
uv[23][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.05,0.14,0.25,0.38,0.51,0.63,0.75,0.85,0.93);
uv[24][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.06,0.15,0.28,0.41,0.56,0.69,0.81,0.92,1.00);
uv[25][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.07,0.16,0.30,0.44,0.59,0.73,0.86,0.96,1.04);
uv[26][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.07,0.17,0.31,0.46,0.61,0.76,0.88,0.98,1.05);
uv[27][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.08,0.18,0.32,0.47,0.62,0.76,0.88,0.97,1.03);
uv[28][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.08,0.18,0.32,0.46,0.61,0.74,0.85,0.93,0.98);
uv[29][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.08,0.18,0.31,0.44,0.57,0.69,0.79,0.86,0.90);
uv[30][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.08,0.17,0.28,0.40,0.52,0.62,0.71,0.77,0.80);
uv[31][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.08,0.15,0.25,0.35,0.45,0.54,0.61,0.66,0.69);
uv[32][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.07,0.13,0.21,0.30,0.38,0.45,0.50,0.54,0.56);
uv[33][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.02,0.06,0.11,0.17,0.23,0.30,0.35,0.39,0.42,0.44);
uv[34][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.04,0.08,0.13,0.17,0.22,0.26,0.29,0.31,0.32);
uv[35][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.03,0.06,0.09,0.12,0.15,0.17,0.19,0.21,0.22);
uv[36][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.03,0.05,0.07,0.09,0.10,0.12,0.13,0.13);
uv[37][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.02,0.03,0.04,0.05,0.06,0.07,0.07);
uv[38][18] = new Array(0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.01,0.01,0.02,0.02,0.02);
uv[39][18] = new Array(0.01,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[40][18] = new Array(0.04,0.03,0.03,0.02,0.01,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[41][18] = new Array(0.09,0.07,0.06,0.05,0.03,0.02,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[42][18] = new Array(0.16,0.13,0.10,0.08,0.06,0.04,0.02,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[43][18] = new Array(0.24,0.20,0.16,0.13,0.09,0.06,0.03,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[44][18] = new Array(0.34,0.29,0.23,0.18,0.13,0.09,0.05,0.01,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[45][18] = new Array(0.46,0.39,0.32,0.25,0.18,0.12,0.07,0.02,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[46][18] = new Array(0.58,0.50,0.41,0.32,0.24,0.16,0.09,0.04,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[47][18] = new Array(0.71,0.62,0.51,0.41,0.30,0.21,0.12,0.05,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[48][18] = new Array(0.84,0.73,0.61,0.49,0.37,0.26,0.15,0.07,0.01,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[49][18] = new Array(0.95,0.84,0.71,0.58,0.44,0.31,0.19,0.09,0.02,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[50][18] = new Array(1.04,0.93,0.80,0.66,0.51,0.37,0.23,0.12,0.04,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[51][18] = new Array(1.10,1.00,0.87,0.73,0.57,0.42,0.27,0.15,0.05,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[52][18] = new Array(1.12,1.03,0.91,0.78,0.62,0.46,0.31,0.17,0.07,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);
uv[53][18] = new Array(1.10,1.03,0.93,0.80,0.65,0.49,0.33,0.20,0.08,0.01,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00);

//Ti.include("uvdata.js");
var safetime;

function getsafetime(lat, indate, uvcalchour, skin, shadow, inputuvindex, summertime) {
	// olika hudtypers erytemdoskÃ¤nslighet i Joule per kvadratmeter
	skins = new Array();
	skins[1] = 200; // 180;
	skins[2] = 300; // 250;
	skins[3] = 400; // 400;

	// SOFTRONIC, STEFAN FRIMAN - 2013-12-12 || 	ADDING 3 SKINTYPES
	skins[4] = 600;
	skins[5] = 800;
	skins[6] = 1000;
	// -- SOFTRONIC

	//    skins[1] = 180; // 180;
	//    skins[2] = 250; // 250;
	//    skins[3] = 400; // 400;

	// rak interpolering mellan datum...
	// rak interpolering mellan latituder...

	// get day of year from date
	////dayofyear = date("z",strtotime(date));

	date_year = indate.substring(0, 4);
	date_month = indate.substring(5, 7);
	date_day = indate.substring(8, 10);

	if (date_month.substring(0, 1) == "0") {
		date_month = parseInt(date_month.substring(1, 2)) - 1;
	} else {
		date_month = parseInt(date_month) - 1;
	}

	if (date_day.substring(0, 1) == "0") {
		date_day = parseInt(date_day.substring(1, 2));
	} else {
		date_day = parseInt(date_day);
	}

	dayofyear_date = new Date(date_year, date_month, date_day, 0, 0, 0);
	dayofyear_date.setTime(dayofyear_date.getTime());
	onejan = new Date(dayofyear_date.getFullYear(), 0, 1, 0, 0, 0);
	//dayofyear =  Math.ceil((dayofyear_date.getTime() - onejan.getTime()) / 86400000);
	dayofyear = Math.ceil((dayofyear_date.getTime() - onejan.getTime()) / 86400000);

	// don't use real weeknumber, use dayofyear/7!

	week = Math.ceil((dayofyear + 1) / 7);
	//dbgecho ("Latitud: $lat, Datum: $date, Klockan: $uvcalchour, Hudtyp: $skin, Vecka: $week, Skugga: $shadow",9);
	// use week 52 as UV for week 53 == week 1 if firstweek is here!


	totalexposure = 0;
	// can be in sun more than one uvcalchour, recalculate
	tt = 0;
	dobreak = 0;
	while (totalexposure <= skins[skin] && tt <= 4) {
		tt++;
		exposure = (calculateuv(dayofyear, uvcalchour - summertime, lat, inputuvindex) * 0.025) * ((100 - shadow) / 100);
		//Ti.API.info('SAFE: '+exposure);

		if (exposure == 0) { dobreak = 99; continue; }

		safetime = (skins[skin] - (totalexposure)) / exposure;

		totalexposure += (exposure * 60 * 60);

		//dbgecho ("<strong>Erythemal Dos efter $tt timmar: +" . round($exposure*60*60) ." = totalt " . round($totalexposure) . " (huden t&aringl: $skins[$skin])</strong>" ,6);
		//dbgecho ("BerÃ¤knar UV klockan $uvcalchour (timme nummer $tt) Prognos " .$safetime/60,7);
		uvcalchour++;

		if (uvcalchour == 18) {
			dobreak = 99;
			continue;
		}
	}


	safetime = safetime / 60 / 60;


	if (dobreak != 99) {
		//dbgecho ("SÃ¤ker soltid: " . decimal_to_time($tt-1+($safetime)),9);
		temp_safe_time = tt - 1 + (safetime);
		//alert("SÃ¤ker soltid: " + decimal_to_time(temp_safe_time));

		//return decimal_to_time(temp_safe_time);this was used before commented on 8 cot

		temp_safe_time = Math.round(temp_safe_time * 60);

		return temp_safe_time;

		//return decimal_to_time(temp_safe_time);
		//temp_safe_time = Math.round(temp_safe_time * 60);

		//return temp_safe_time;
	} else {
		return (dobreak) //99 means zero exposore
		//dbgecho ("SÃ¤ker soltid: resten av dagen");
		//return("SÃ¤ker soltid: resten av dagen");
		//alert('3');
		return "";
	}


}

function getUV(indate, uvcalchour, lat) {

	date_year = indate.substring(0, 4);
	date_month = indate.substring(5, 7);
	date_day = indate.substring(8, 10);

	if (date_month.substring(0, 1) == "0") {
		date_month = parseInt(date_month.substring(1, 2)) - 1;
	} else {
		date_month = parseInt(date_month) - 1;
	}

	if (date_day.substring(0, 1) == "0") {
		date_day = parseInt(date_day.substring(1, 2));
	} else {
		date_day = parseInt(date_day);
	}

	dayofyear_date = new Date(date_year, date_month, date_day, 0, 0, 0);
	dayofyear_date.setTime(dayofyear_date.getTime());
	onejan = new Date(dayofyear_date.getFullYear(), 0, 1, 0, 0, 0);
	//dayofyear =  Math.ceil((dayofyear_date.getTime() - onejan.getTime()) / 86400000);
	dayofyear = Math.ceil((dayofyear_date.getTime() - onejan.getTime()) / 86400000);

	//return calculateuv(68,10,9, "");

	lat = Math.round(parseInt(lat));

	return (Math.round(calculateuv(dayofyear, uvcalchour, lat, "")));
	// alert(calculateuv(254,15,52, ""));
}



function calculateuv(dayofyear, subhour, lat, retuv) {
	if (retuv != "" && retuv != -1) {
		return parseInt(retuv);
	}

	if (subhour > 17) {
		return 0;
	}

	if (subhour < 8) {
		subhour = 8;
	}

	//if(k < 8) { subhour = 8; } commented by db
	//subhour = 8;
	latindex = Math.ceil((lat + 90) / 10);
	//dbgecho ("Latitudindex: $latindex",2);
	week = Math.ceil((dayofyear + 1) / 7);
	prevlatindex = latindex - 1 >= 0 ? latindex - 1 : 0;
	//prevweek = week - 1 >= 0 ? week - 1 : 52; changed to handle 1st week error
	prevweek = week - 1 > 0 ? week - 1 : 52;
	week_rest = (dayofyear) % 7;
	latindex_rest = (lat + 90) % 10;

	//if(latindex_rest > 0) dbgecho ("Interpolerar latitud, rest: $latindex_rest ",5);
	//if(week_rest > 0) dbgecho ("Interpolerar datum, rest: $week_rest",5);

	uv2 = uv[prevweek][subhour][latindex] / 7 * week_rest + uv[week][subhour][latindex] / 7 * (7 - week_rest);
	uv1 = uv[prevweek][subhour][prevlatindex] / 7 * week_rest + uv[week][subhour][prevlatindex] / 7 * (7 - week_rest);

	uvindex = latindex_rest > 0 ? (uv2 / 10 * latindex_rest) + (uv1 / 10 * (10 - latindex_rest)) : uv2;

	//console.log("FÃ¶reg. vecka: " + prevweek + ", Timme: " + subhour + ", Lat1: " + latindex + ", Lat2: " + prevlatindex);
	//console.log("UV lÃ¤gre latitud: " + uv1);
	//console.log("UV hÃ¶gre latitud: " + uv2);
	//console.log("UV klockan " + subhour + " Ã¤r " + uvindex);

	/*
	dbgecho ( "UV lÃ¤gre latitud: " . $uv1 . "",2);
	dbgecho ( "UV hÃ¶gre latitud: " . $uv2 . "",2);
	dbgecho ( "<strong>UV klockan $uvcalchour:00 Ã¤r " . $uvindex . "</strong>",8);
	*/

	return uvindex;
}

function calcUVGraphData(date, lat)
{
	date_year = indate.substring(0, 4);
	date_month = indate.substring(5, 7);
	date_day = indate.substring(8, 10);

	if (date_month.substring(0, 1) == "0") {
		date_month = parseInt(date_month.substring(1, 2)) - 1;
	} else {
		date_month = parseInt(date_month) - 1;
	}

	if (date_day.substring(0, 1) == "0") {
		date_day = parseInt(date_day.substring(1, 2));
	} else {
		date_day = parseInt(date_day);
	}

	dayofyear_date = new Date(date_year, date_month, date_day, 0, 0, 0);
	dayofyear_date.setTime(dayofyear_date.getTime());
	onejan = new Date(dayofyear_date.getFullYear(), 0, 1, 0, 0, 0);
	dayofyear = Math.ceil((dayofyear_date.getTime() - onejan.getTime()) / 86400000);

	lat = Math.round(parseInt(lat));

	var data = [];
	for (var i = 8; i < 19; i++) {
		data.push([(i < 10 ? "0" : "" + i + ":00"), (Math.round(calculateuv(dayofyear, i, lat, "")))]);
	}

	return data;
}

function decimal_to_time(decimal) {
	// konvertera decimal till timmar:minuter
	rest = decimal - Math.floor(decimal);

	temp_uvcalchour = Math.floor(decimal);
	temp_min = Math.round(rest * 60);

	if (temp_min < 10) {
		temp_min = "0" + temp_min;
	}

	return temp_uvcalchour + ":" + temp_min;
	//return floor($decimal) . ":" . str_pad(round($rest*60),2,"0",STR_PAD_LEFT);
}

////var win = Titanium.UI.currentWindow;
//win.backgroundImage = 'images/bakground.png';
//Ti.include("uvcalc.js");

var fontSmall1 = false;
var fontSmall2 = false;
var fontSmall3 = false;
var pickValid = true;
var uvResultat = '';
var indate ='2012-03-12';
var hour = 12;
var lat = 55;
var mittUV = 0;
var skin = 1;
var shadow = 25;
var age = 3;
var now_date = new Date();
var now_year = now_date.getFullYear();
var now_month = now_date.getMonth()+1;
var hour = now_date.getHours();
var minutesCheck = now_date.getMinutes();

Date.prototype.stdTimezoneOffset = function() {
	var jan = new Date(this.getFullYear(), 0, 1);
	var jul = new Date(this.getFullYear(), 6, 1);
	return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

Date.prototype.dst = function() {
	return this.getTimezoneOffset() < this.stdTimezoneOffset();
}

var todaySummertimeChecker = new Date();

if(todaySummertimeChecker.dst())
{
	var summerTime = 1;
} else {
	var summerTime = 0;
}

	if(minutesCheck >= 30){
		hour = hour + 1;
	}
	if(hour < 8){
		hour = 8;
	}else if(hour >18){
		hour = 18;
	}

//Ti.App.Properties.setString('theHour',hour);

var latSet = false;
var uvSet = false;

	if(now_month < 10)
	{
		now_month = "0"+now_month;
	}
	now_day = now_date.getDate();

	if(now_day < 10)
	{
		now_day = "0" + now_day;
	}
	indate = now_year + "-" + now_month + "-" + now_day;


function roundtime(uvres) {

	var Minutes;
	if(uvres > 0 && uvres < 5) { uvres = 5; }
    if(uvres>180) {
         Minutes = Math.round(uvres/30)*30;
    } else {
        Minutes = Math.round(uvres/5)*5;
    }

	var Hours = Math.floor(Minutes/60);
	Minutes = Minutes - Hours * 60;
	if (Minutes < 10){
         Minutes = '0'+ Minutes;
	}
    return {
    'Hours': Hours,
    'Minutes': Minutes
	};
}

function GetDateFormate()
{
	//console.log('GetDateFormate in');
	// SOFTRONIC STEFAN FRIMAN - 20131212
	var rawDate = document.getElementById("dateofexposure").value;
	var currentTime = parseDate(rawDate,'0:0');
	//var currentTime = parseDate(rawDate);
	// -- SOFTRONIC
	var month = currentTime.getMonth() + 1;
	var day = currentTime.getDate();
	var year = currentTime.getFullYear();

	if (month < 10)
		month = '0' + month; // To append leading zero

	if (day < 10)
		day = '0' + day; // To append leading zero

	//console.log('GetDateFormate ut');
	return (year + "-" + month + "-" + day);
}

function ReCalcutateResult()
{
	//console.log('ReCalcutateResult in');
	document.getElementById('inputfields').style.display = '';
	document.getElementById('CalcResult').style.display = 'none';
	//console.log('ReCalcutateResult ut');
}

function Validation()
{
	//console.log('Validation in');

	var result = true;
	var lat = document.getElementById("Location").value;
	var time = document.getElementById("Timeofday").value;
	var date = document.getElementById("dateofexposure").value;
	var inpUvIndex = document.getElementById("inpUVindex").value;

	if (inpUvIndex)
	{
		if (inpUvIndex > 30) {
			$("#inpUVindex").addClass(invalid);
			result = false;
		}
		else
			$("#inpUVindex").removeClass(invalid);
	}
	else
	{
		if (lat == 0) {
			$("#Location").addClass(invalid);
			result = false;
		}
		else {
			$("#Location").removeClass(invalid);
		}

		if (time == 0) {
			$("#Timeofday").addClass(invalid);
			result = false;
		}
		else {
			$("#Timeofday").removeClass(invalid);
		}

		if (date == '') {
			$("#dateofexposure").addClass(invalid);
			result = false;
		}
		else {
			$("#dateofexposure").removeClass(invalid);
		}
	}

	//console.log('Validation ut');
	return result;
}

//FIX: otherwise not waiting for jquery to load in ie9
setTimeout(function(){

	// SOFTRONIC STEFAN FRIMAN 2013-12-12
	$(function () {
		//console.log('#dateofexposure init in');
		$("#dateofexposure").on("change", function () {
			//console.log('#dateofexposure change in');
			if ($("#dateofexposure").val() == '') {
				$("#dateofexposure").addClass(invalid);
			}
			else {
				$("#dateofexposure").removeClass(invalid);
			}
			//console.log('#dateofexposure change ut');
		});
		//console.log('#dateofexposure init ut');
	});
	// -- SOFTRONIC

	$(function () {
		//console.log('#Location init in');
		$("#Location").on("change", function () {
			//console.log('#Location change in');
			if ($("#Location").val() == 0) {
				//                $("#Location").addClass(invalid);
			}
			else {
				//CheckTimeOffset();
				$("#Location").removeClass(invalid);
				$("#inpUVindex").val("");

			}
			//console.log('#Location change ut');
		});
		//console.log('#Location init ut');
	});

	$(function () {
		//console.log('#Timeofday init in');
		$("#Timeofday").on("change", function () {
			//console.log('#Timeofday change in');
			if ($("#Timeofday").val() == 0) {
				//                $("#Timeofday").addClass(invalid);
			}
			else {
				$("#inpUVindex").val("");
				$("#Timeofday").removeClass(invalid);
			}
			//console.log('#Timeofday change ut');
		});
		//console.log('#Timeofday init ut');
	});

	$(document).ready(function ()
	{
		//console.log('#DocumentReady in');

        $("#Calculate").on("click", CalcutateResult);
        $("#Recalculate").on("click", ReCalcutateResult);

		$("#inpUVindex").keydown(function (event)
		{
			//console.log('#inpUVindex keydown in');

			// If i add Plats and Tid -  shall ”Eller fyll i UV-index” be blocked (Custom validation)

			var lat = document.getElementById("Location").value;
			var time = document.getElementById("Timeofday").value;
			//To prevent entering UV index
			//            if ((lat != 0) || (time != 0)) {

			//                event.preventDefault();
			//            }

			$("#Location").val("0");
			$("#Timeofday").val("0");



			// Allow: backspace, delete, tab, escape, and enter
			if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
				// Allow: Ctrl+A
			(event.keyCode == 65 && event.ctrlKey === true) ||
				// Allow: home, end, left, right
			(event.keyCode >= 35 && event.keyCode <= 39)) {
				// let it happen, don't do anything
				//console.log('#inpUVindex keydown ut');
				return;
			}
			else {
				// Ensure that it is a number and stop the keypress
				if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
					event.preventDefault();
				}
			}
			//console.log('#inpUVindex keydown ut');
		});
		//console.log('#DocumentReady ur');
	});


	$(document).ready(function()
	{
		//console.log('Setup Load in');
		var displayUv = Checkdisplaymode();

		var listItems = "";
		for (var i = 0; i < jsonList.Places.length; i++)
		{
			listItems += "<option value='" + jsonList.Places[i].lat + "'>" + jsonList.Places[i].title + "</option>";
		}
		$("#Location").html(listItems);
		$("#UVIndexLocation").html(listItems);

		if(displayUv)
		{
			//console.log('Setup #uvDate in');
			$("#uvDate").on("change", function ()
			{
				if ($("#uvDate").val() == '')
					$("#uvDate").addClass(invalid);
				else
					$("#uvDate").removeClass(invalid);

				CalculateUvResult();
			});

			$("#uvTime").on("change", function ()
			{
				if ($("#uvTime").val() == '0')
					$("#uvTime").addClass(invalid);
				else
					$("#uvTime").removeClass(invalid);

				CalculateUvResult();
			});
			//console.log('Setup #uvDate ut');

			//console.log('Setup #UVIndexLocation in');
			$("#UVIndexLocation").on("change", function ()
			{
				if ($("#UVIndexLocation").val() == 0)
					$("#UVIndexLocation").addClass(invalid);
				else
					$("#UVIndexLocation").removeClass(invalid);

				CalculateUvResult();
			});
			//console.log('Setup #UVIndexLocation ut');

			DefaultSelection();
		}
		//console.log('Setup Load ut');
	});


	$('.close_btn').click(function () {
		$('.window').hide();
	});

}, 0);

// SOFTRONIC
// parse a date in ISO-8601 format
function parseDate(date, time)
{
	//console.log('parseDate in: ' + date + ', ' + time);

	var timeParts = (time + '').split(':');

	// Determine type of object, date or string.
	if( date instanceof Date)
	{
		// if already a date, just set time and return it.
		if( timeParts.length > 0 )
			date.setHours(timeParts[0]);

		//console.log('parseDate (date) ut: ' + _date);
		return date;
	}
	else
	{
		// if not a date, assume it's a string and parse it according to ISO-8601 (yyyy-mm-dd)
		var dateParts = (date + '').split('-');

		//console.log('Parse: ' + dateParts.length + ', ' + dateParts[0] + ', ' + dateParts[1] + ', ' + dateParts[2] );

		var _date = new Date(dateParts[0], dateParts[1]-1, dateParts[2], timeParts[0]); // months are 0-based

		//console.log('parseDate (string) ut: ' + _date);
		return _date;
	}
}
// -- SOFTRONIC

Date.prototype.stdTimezoneOffset = function () {
	var jan = new Date(this.getFullYear(), 0, 1);
	var jul = new Date(this.getFullYear(), 6, 1);
	return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

Date.prototype.dst = function () {
	return this.getTimezoneOffset() < this.stdTimezoneOffset();
}

var summerTime = 0;
function CalcutateResult() {

	var todaySummertimeChecker = new Date();

	//HÄR MÅSTE VI HA IN EN FUNKTION FÖR ATT KOLLA OM DET ÄR SOMMARTID ELLER EJ.
	//OM DET ÄR SOMMARTID SKA summerTime vara 1, annars 0
	if (todaySummertimeChecker.dst()) {
		summerTime = 1;
	} else {
		summerTime = 0;
	}

	//Validation Starts
	Validation();
	// Validation ends

	if ($('#infant')[0].checked == true) {
		alert('Spädbarn ska inte vistas i solen');
		return;
	}
	// user inputs
	var CalUV = -1;

	// SOFTRONIC
	var indate = GetDateFormate();
	// -- SOFTRONIC

	var dispHour = document.getElementById("Timeofday").value;
	var hour = parseInt(dispHour); //  - summerTime;

	var latitude = Math.round(document.getElementById("Location").value);
	var inUvIndex = document.getElementById("inpUVindex").value;

	if (inUvIndex)
	{
		//var currentHour = new Date();
		CalUV = inUvIndex;
		hour = 12; //currentHour.getHours();
		latitude = 0;
	}

	var SkinType = 1;

	for (i = 0; i < document.getElementsByName('SkinType').length; i++)
	{
		if (document.getElementsByName('SkinType')[i].checked == true)
		{
			SkinType = document.getElementsByName('SkinType')[i].value;
			break;
		}
	}

	if (Validation() && !($('#infant').attr('checked')))
	{
		document.getElementById('inputfields').style.display = 'none';
		document.getElementById('CalcResult').style.display = '';

		//Get UV index Image
		var loc = '';
		var locD = document.getElementById('Location');
		if (inUvIndex)
		{
			GetUVindeximg(inUvIndex);
			loc = 'UV index: ' + inUvIndex;
		}
		else
		{
			GetUVindeximg(getUV(indate, hour - summerTime, latitude));
			loc = locD[locD.selectedIndex].text;
		}

		//if (inUvIndex) //IF UV index is provided the default time should be 12
		//	hour = 12;

		$('#info').html( loc + ', ' + indate + '<h2>Så länge kan du vistas ute från kl. ' + dispHour + ':00</h2>'  );
		//$('#info').html('Så länge kan du vistas ute från kl. ' + hour + ':00');
		// -- SOFTRONIC

		$(window).scrollTop($("#CalcResult").offset().top);

		var uvresultat1 = getsafetime(parseInt(latitude), indate, hour, SkinType, 0, CalUV, summerTime);
		var uvresultat2 = getsafetime(parseInt(latitude), indate, hour, SkinType, 50, CalUV, summerTime);
		var uvresultat3 = getsafetime(parseInt(latitude), indate, hour, SkinType, 75, CalUV, summerTime);
		/*To check the safe time calculation*/
		var uvresultatEtt = extraCheckTime((uvresultat1), hour); //uvresultat1;
		var uvresultatTwo = extraCheckTime((uvresultat2), hour); //uvresultat2;  //
		var uvresultatThree = extraCheckTime((uvresultat3), hour); // uvresultat3; //
		/*To check the safe time*/
		document.getElementById('spsunSelected').innerHTML = uvresultatEtt == 99 ? 'till kvällen' : roundtime(uvresultatEtt).Hours + ":" + roundtime(uvresultatEtt).Minutes;
		document.getElementById('spparsolSelected').innerHTML = uvresultatTwo == 99 ? 'till kvällen' : roundtime(uvresultatTwo).Hours + ":" + roundtime(uvresultatTwo).Minutes;
		document.getElementById('spverandaSelected').innerHTML = uvresultatThree == 99 ? 'till kvällen' : roundtime(uvresultatThree).Hours + ":" + roundtime(uvresultatThree).Minutes;

    }
}

function extraCheckTime(timeToCheck, checkHour) {

	//console.log('extraCheckTime in: ' + timeToCheck + ', ' + checkHour);

	timeobj = roundtime(timeToCheck);
	checkDate = new Date(); //Current Date time
	orgDay = checkDate.getDate(); //Current Datw
	checkDate.setHours(checkHour); //Current date's time set to seleted time
	//alert('1checkDate:' + checkDate);
	checkDate.setHours(checkDate.getHours() + timeobj.Hours);
	// alert('2checkDate:' + checkDate);
	checkDate.setMinutes(timeobj.Minutes);
	//  alert('3checkDate:' + checkDate);

	//console.log('extraCheckTime ut');
	if (orgDay != checkDate.getDate()) // if the date changes
	{
		return 99; //'till kvällen'
	}
	if (checkDate.getHours() > 18) // If hous is more then 18
	{
		return 99; //'till kvällen'
	}

	return timeToCheck;
}

// To get Image of the Uvindex
function GetUVindeximg(uvImg) {

	//console.log('GetUVindeximg in: ' + uvImg);

	if (uvImg < 0)
	{
		uvImg = 0;
	}
	else if (uvImg > 11)
	{
		uvImg = 11;
	}

	$('#imguvIndex').attr('src', '/assets/img/min-soltid/uvIndex-' + uvImg + '.png');
	$('#uvindexImageIndi').attr('src', '/assets/img/min-soltid/uvIndex-' + uvImg + '.png');

	//console.log('GetUVindeximg ut');

}



var Pcollection={"Places": [ {title:'Välj plats från lista',lat:'0', selectedColor:'#fff'},
        {title:'Argentina (Buenos Aires)',lat:'-34.60842', selectedColor:'#fff'},
       	{title:'Aruba',lat:'12.52111', selectedColor:'#fff'},
	{title:'Australien (Brisbane)',lat:'-27.47093', selectedColor:'#fff'},
	{title:'Australien (Darwin)',lat:'-12.46282', selectedColor:'#fff'},
	{title:'Australien (Sydney)',lat:'-33.87365', selectedColor:'#fff'},
	{title:'Azorerna',lat:'38.0', selectedColor:'#fff'},
	{title:'Bahamas',lat:'25.03428', selectedColor:'#fff'},
{title:'Bali',lat:' -8.40945', selectedColor:'#fff'},
	{title:'Barbados',lat:'13.193887', selectedColor:'#fff'},
	{title:'Brasilien (Rio de Janerio)',lat:'-22.90354', selectedColor:'#fff'},
	{title:'Brasilien (Salvador)',lat:'-12.97038', selectedColor:'#fff'},
	{title:'Bulgarien (Burgas)',lat:'42.49768', selectedColor:'#fff'},
{title:'Burma (Rangoon)',lat:'16.78077', selectedColor:'#fff'},
	{title:'Chile (Iquique)',lat:'-20.21670', selectedColor:'#fff'},
	{title:'Chile (Santiago)',lat:'-33.41667', selectedColor:'#fff'},
	{title:'Cypern',lat:'34.957995', selectedColor:'#fff'},
	{title:'Costa Rica',lat:'9.748917', selectedColor:'#fff'},
	{title:'Danmark (Köpenhamn)',lat:'55.67610', selectedColor:'#fff'},
	{title:'Danmark (Bornholm)',lat:'55.09723', selectedColor:'#fff'},
	{title:'Dominikanska republiken',lat:'18.735693', selectedColor:'#fff'},
	{title:'Dubai',lat:'25.2644444', selectedColor:'#fff'},
	{title:'Egypten (Kairo)',lat:'30.04442', selectedColor:'#fff'},
	{title:'Egypten (Hurghada)',lat:'27.257896', selectedColor:'#fff'},
	{title:'Egypten (Sharm el Sheikh)',lat:'27.915818', selectedColor:'#fff'},
	{title:'England (London)',lat:'51.50813', selectedColor:'#fff'},
	{title:'Filippinerna (Manilla)',lat:'14.59953', selectedColor:'#fff'},
	{title:'Finland (Helsingfors)',lat:'60.16985', selectedColor:'#fff'},
	{title:'Frankrike (Nice)',lat:'43.69604', selectedColor:'#fff'},
	{title:'Frankrike (Paris)',lat:'48.85661', selectedColor:'#fff'},
{title:'Fuerteventura',lat:'28.35874', selectedColor:'#fff'},

	{title:'Förenade Arabemiraten',lat:'23.424076', selectedColor:'#fff'},
	{title:'Gambia',lat:'13.443182', selectedColor:'#fff'},
	{title:'Grekland (Aten)',lat:'37.97534', selectedColor:'#fff'},
	{title:'Grekland (Kreta)',lat:'35.24012', selectedColor:'#fff'},
	{title:'Grekland (Rhodos)',lat:'36.191092', selectedColor:'#fff'},
	{title:'Haiti',lat:'18.97119', selectedColor:'#fff'},
	{title:'Indien (Goa)',lat:'15.29933', selectedColor:'#fff'},
	{title:'Indien (Mumbai)',lat:'19.01761', selectedColor:'#fff'},
	{title:'Indonesien',lat:'-0.789275', selectedColor:'#fff'},
{title:'Iran (Teheran)',lat:'35.69611', selectedColor:'#fff'},
	{title:'Israel',lat:'31.046051', selectedColor:'#fff'},
	{title:'Italien (Rom)',lat:'41.89052', selectedColor:'#fff'},
{title:'Italien (Sicilien)',lat:'37.59247', selectedColor:'#fff'},

	{title:'Italien (Venedig)',lat:'45.43434', selectedColor:'#fff'},
	{title:'Jamaica',lat:'18.10958', selectedColor:'#fff'},
	{title:'Japan (Tokyo) ',lat:'35.68949', selectedColor:'#fff'},
	{title:'Jordanien',lat:'30.585164', selectedColor:'#fff'},
	{title:'Kanarieöarna (Las Palmas)',lat:'28.12482', selectedColor:'#fff'},
	{title:'Kap Verde',lat:'16.002082', selectedColor:'#fff'},
	{title:'Kenya (Nairobi)',lat:'-1.28333', selectedColor:'#fff'},
	{title:'Kina (Beijing)',lat:'39.90421', selectedColor:'#fff'},
	{title:'Kina (Hainan)',lat:'18.16674', selectedColor:'#fff'},
	{title:'Kina (Hong Kong)',lat:'22.39643', selectedColor:'#fff'},
	{title:'Kina (Lhasa)',lat:'29.57346', selectedColor:'#fff'},
	{title:'Kina (Shanghai)',lat:'31.23039', selectedColor:'#fff'},
	{title:'Kina (Xian)',lat:'34.37972', selectedColor:'#fff'},
	{title:'Kroatien',lat:'45.1', selectedColor:'#fff'},
{title:'Kroatien (Split)',lat:'43.50811', selectedColor:'#fff'},
	{title:'Kuba',lat:'21.521757', selectedColor:'#fff'},
{title:'Lanzarote',lat:'29.04685', selectedColor:'#fff'},

	{title:'Lettland (Riga)',lat:'56.94620', selectedColor:'#fff'},
	{title:'Malaysia (Kuala Lumpur)',lat:'3.13900', selectedColor:'#fff'},
	{title:'Maldiverna',lat:'3.202778', selectedColor:'#fff'},
	{title:'Malta',lat:'35.937496', selectedColor:'#fff'},
	{title:'Marocko (Marrakech)',lat:'31.63132', selectedColor:'#fff'},
	{title:'Mauritius',lat:'-20.348404', selectedColor:'#fff'},
	{title:'Mexico (Cancún)',lat:'21.16188', selectedColor:'#fff'},
{title:'Mexico City',lat:'19.43261', selectedColor:'#fff'},
	{title:'Mocambique',lat:'-18.665695', selectedColor:'#fff'},
	{title:'Norge (Oslo)',lat:'59.91387', selectedColor:'#fff'},
	{title:'Nya Zeeland (Auckland)',lat:'-36.84846', selectedColor:'#fff'},

	{title:'Nya Zeeland (Wellington)',lat:'-41.28646', selectedColor:'#fff'},
	{title:'Oman',lat:'21.512583', selectedColor:'#fff'},
{title:'Panama',lat:'8.53798', selectedColor:'#fff'},

	{title:'Polen',lat:'51.919438', selectedColor:'#fff'},
	{title:'Portugal (Lissabon)',lat:'38.70693', selectedColor:'#fff'},
	{title:'Portugal (Madeira)',lat:'32.760707', selectedColor:'#fff'},
{title:'Seychellerna',lat:'-4.67957', selectedColor:'#fff'},

	{title:'Singapore',lat:'1.352083', selectedColor:'#fff'},
	{title:'Skottland (Edinburgh)',lat:'55.95325', selectedColor:'#fff'},
	{title:'Spanien (Barcelona)',lat:'41.38792', selectedColor:'#fff'},
	{title:'Spanien (Madrid)',lat:'40.41669', selectedColor:'#fff'},
	{title:'Spanien (Malaga)',lat:'36.71965', selectedColor:'#fff'},
	{title:'Spanien (Mallorca)',lat:'39.6952629', selectedColor:'#fff'},
	{title:'Spanien (Marbella)',lat:'36.50994', selectedColor:'#fff'},
	{title:'Sri Lanka',lat:'7.873054', selectedColor:'#fff'},
	{title:'Sverige (Gotland)',lat:'57.621875', selectedColor:'#fff'},
{title:'Sverige (Göteborg)',lat:'57.70887', selectedColor:'#fff'},

	{title:'Sverige (Malmö)',lat:'55.60498', selectedColor:'#fff'},
	{title:'Sverige (polcirkeln)',lat:'66.54772', selectedColor:'#fff'},
	{title:'Sverige (Stockholm)',lat:'59.32893', selectedColor:'#fff'},
	{title:'Sverige (Öland)',lat:'58.866991', selectedColor:'#fff'},
{title:'Sverige (Östersund)',lat:'63.17668', selectedColor:'#fff'},

	{title:'Sydafrika',lat:'-30.559482', selectedColor:'#fff'},
	{title:'Tanzania',lat:'-6.369028', selectedColor:'#fff'},
	{title:'Teneriffa',lat:'28.2915637', selectedColor:'#fff'},
	{title:'Thailand (Bangkok)',lat:'13.72342', selectedColor:'#fff'},
	{title:'Thailand (Phuket)',lat:'8.02659', selectedColor:'#fff'},
	{title:'Tjeckien (Prag)',lat:'50.08781', selectedColor:'#fff'},
	{title:'Trinidad och Tobago',lat:'10.691803', selectedColor:'#fff'},
	{title:'Tunisien',lat:'33.886917', selectedColor:'#fff'},
	{title:'Turkiet (Antalaya)',lat:'36.879621', selectedColor:'#fff'},
	{title:'Turkiet (Istanbul)',lat:'40.963308', selectedColor:'#fff'},
	{title:'Tyskland (Berlin)',lat:'52.52427', selectedColor:'#fff'},
	{title:'Ungern (Budapest)',lat:'47.49841', selectedColor:'#fff'},
	{title:'USA (Los Angeles)',lat:'34.05223', selectedColor:'#fff'},
	{title:'USA (Miami)',lat:'25.78897', selectedColor:'#fff'},
	{title:'USA (New York)',lat:'40.71435', selectedColor:'#fff'},
	{title:'Venezuela',lat:'6.42375', selectedColor:'#fff'},
	{title:'Vietnam (Ho Chi Minh)',lat:'10.82310', selectedColor:'#fff'},
	{title:'Vietnam (Hanoi)',lat:'21.03333', selectedColor:'#fff'},
	{title:'Åland',lat:'60.056616', selectedColor:'#fff'}]}
        ;
var jsonList=Pcollection;
var displayMinSol = (1 == 1);

//To select default selection for plats
function DefaultSelection()
{
	//console.log('DefaultSelection in');
	var CurrenpageProp=57.57478;// to get the current page property }
	$("#UVIndexLocation").val(CurrenpageProp);
	SetDateTimeDefaults();
	CalculateUvResult();
	//console.log('DefaultSelection ut');
}

//To check Display mode
function Checkdisplaymode()
{
	//console.log('Checkdisplaymode in');

	var DisplaySelection=$('main').data('displayUv');

	if (! DisplaySelection)
	{
		$("#UvDisplay").hide();
		$("#MinSolar").show();
	}
	else
	{
		$("#MinSolar").hide();
		$("#UvDisplay").show();
	}

	return DisplaySelection;
	//console.log('Checkdisplaymode ut');
}

function ValidateUV()
{
	//console.log('ValidateUV in');
	var date = $('#uvDate').val();
	var time = $('#uvTime').val();
	var place = $('#UVIndexLocation').val();

	if (place == 0)
		$("#UVIndexLocation").addClass(invalid);
	else
		$("#UVIndexLocation").removeClass(invalid);

	if (time == 0)
		$("#uvTime").addClass(invalid);
	else
		$("#uvTime").removeClass(invalid);

	if (date == '')
		$("#uvDate").addClass(invalid);
	else
		$("#uvDate").removeClass(invalid);

	//console.log('Validate ut');
}

function isValid()
{
	//console.log('isValid in');

	var date = $('#uvDate').val();
	var time = $('#uvTime').val();
	var place = $('#UVIndexLocation').val();
	var valid = date != '' && time != 0 && place != 0;

	//console.log('isValid ut: ' + valid);
	return valid;
}

function ResetUvView()
{
	//console.log('ResetUvView in');
	$('#CurrentDate').html('');
	$('#Time').html('');
	$('#Plats').html('');
	$('#UVvalue').html('');
	//console.log('ResetUvView ut');
}

function SetDateTimeDefaults()
{
	//console.log('SetDateTimeDefaults in');
	var rawDate = $('#uvDate').val();
	var rawTime = $('#uvTime').val();

	if(rawTime == '0')
	{
		rawTime = new Date().getHours();
		if(rawTime < 8)
			rawTime = 8;
		else if(rawTime > 18)
			rawTime = 18;
		else
			rawTime = 12;
	}

	if(rawDate == '')
		rawDate = new Date();

	$('#uvTime').val(rawTime);

	//console.log('SetDateTimeDefaults ut: ' + $('#uvDate').val() + ", " + $('#uvTime').val());
}

function CalculateUvResult()
{
	//console.log('CalculateUvResult in');
	SetDateTimeDefaults();

	// SOFTRONIC
	ValidateUV();

	if(!isValid())
	{
		// Reset view
		ResetUvView();
		return;
	}

	var rawDate = $('#uvDate').val();
	var rawTime = $('#uvTime').val();

	if(rawTime == '0')
	{
		rawTime = new Date().getHours();
		if(rawTime < 8)
			rawTime = 8;
		else if(rawTime > 18)
			rawTime = 18;
	}

	hour = rawTime;

	if( rawTime < 10)
		rawTime = '0' + rawTime;

	rawTime += ':00';

	var currentTime = parseDate(rawDate, rawTime); // new Date();
	var indate = rawDate; // GetDateFormate(currentTime);

	// To update date
	$('#CurrentDate').html(indate);

	//To update time
	$('#Time').html(rawTime);

	var latitude = document.getElementById("UVIndexLocation").value;

	//Get Selected Plate
	var selected_index = document.getElementById("UVIndexLocation").selectedIndex;
	$('#Plats').html(document.getElementById("UVIndexLocation").options[selected_index].text);
	//Get UV index value
	$('#UVvalue').html(getUV(indate, hour, latitude));

	// Get UV index Image
	GetUVindeximg(getUV(indate, hour, latitude));

	// Setup the graph
	//SetupUVGraph(indate, latitude);
	//console.log('CalculateUvResult ut');
}
